<script>
  import { onMount, afterUpdate } from 'svelte';
  // import { collection, getDocs } from 'firebase/firestore';
  import { db } from './firebase.js';
  import { collection, onSnapshot, addDoc, doc, getDoc, setDoc, query, orderBy, serverTimestamp, where, limit, getDocs, updateDoc } from 'firebase/firestore'; // Add this if using Firebase v9+
  import { getAuth, onAuthStateChanged, signInAnonymously, EmailAuthProvider, signOut, isSignInWithEmailLink } from 'firebase/auth';

  import { getFunctions } from 'firebase/functions';
import { app } from './firebase.js';
  import { httpsCallable } from 'firebase/functions';
   import { fade } from 'svelte/transition';
   import * as firebaseui from 'firebaseui';
     import { tick } from 'svelte';


  import MessageContent from './MessageContent.svelte';
  import LoadingSpinner from './LoadingSpinner.svelte';
  import DotsSpinner from './DotsSpinner.svelte';
  import RoundIcon from './RoundIcon.svelte'; // Adjust the path as needed
  import LoadingModal from './LoadingModal.svelte';
  import Notification from './Notification.svelte';
  import PresetRow from './PresetRow.svelte';
  import Tip from './Tip.svelte';
  import FeedbackForm from "./FeedbackForm.svelte";
  import EditUser from "./EditUser.svelte";
  import EditChat from "./EditChat.svelte";
  import { getAnalytics, logEvent } from "firebase/analytics";
  import PrivacyPolicyModal from './PrivacyPolicyModal.svelte';
  import TermsOfUseModal from './TermsOfUseModal.svelte'; 
  import UploadCustomChat from './UploadCustomChat.svelte'; 




  // This needs to be inline:
	//import AuthUI from './AuthUI.svelte';

	const functions = getFunctions(app);
	const auth = getAuth();
	const analytics = getAnalytics(app);

	// closed beta 
	
	let hasAccess = false;
	if(window.location.origin == "http://localhost:8080") {
		//hasAccess = true;
}
	let token;
	let requestEmail = "";
	let isRequestEmailSuccess = false;
	



	let isAnonymous = true;
	let anonymousUid;
	 let ui;
	let showAuthUI = false;
	let showPrivacyModal = false;
	let showTermsModal = false;

	let pageLoading = true;
	let userAccepted = true;
	let showTip = false;
	let isFbFormOpen = false;

 	let messages = [];
	let chats = [];
	let user = null;
	let dbUser;
	let editingDbUser = false;
	let newMessage = "";
	let currentChatId = null;  // This will hold the ID of the currently selected chat
    let imageLoaded = {};  // Object to track the loading state of each image by its URL
    let isMsgInProgress = false;

    let currTempChat = null;

    let appTitle = "Playfully";
    let appPageTitle = "Playfully AI";

  

  let isDarkMode = true;
  let isMobile = false;
  let isHidden = document.hidden;
  let latestMessageTimestamp = null;
  let prevNotAutomated = null;
  let reloadChats = false;


	let dynamicWidth;
  
  const createChatFunction = httpsCallable(functions, 'createNewChat');

/*
function sleep(ms) {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
console.log(currentDate - date);
    } while (currentDate - date < ms);
}
*/

  onMount(() => {
  	/*
    isDarkMode = localStorage.getItem('dark-mode') === 'true';
    */
	    if (isDarkMode) {
	        document.documentElement.classList.add('dark');
	    } else {
	        document.documentElement.classList.remove('dark');
	    }

	    document.title = appPageTitle;

	    const handleResize = () => {
	    	let parentDiv = document.getElementById('parentDiv'); 
	  		let fixedForm = document.getElementById('fixedForm');
	    	if(fixedForm) {
	    		//console.log("handleResize");
		      isMobile = window.innerWidth <= 640; // This assumes 640px is the breakpoint for mobile
		   		
		   		if(isMobile) {
		   			//$: dynamicWidth = `calc(100% - 60px)`;
		   			fixedForm.style.width = "";
		   			//console.log("isMobile unset fixed width");
		   		} else {
		   			// Calculate the dynamic width for fixed form
	  				//$: dynamicWidth = `calc(100% - 60px)`;
	  				
	  				fixedForm.style.width = `${parentDiv.offsetWidth}px`;
	  				//console.log("!isMobile resize parentDiv width: "+parentDiv.offsetWidth);
		   		} 
		   	}


	    };

	    handleResize(); // Call once on mount
   	 	window.addEventListener('resize', handleResize); // Call on window resize
   	 	document.addEventListener('DOMContentLoaded', function() {
   	 			// call again
			    handleResize();

			    // hack because something is happening after DOMContentLoaded
			     const delays = [100, 500, 1000, 1500];  // Example delays in ms
			    for (let delay of delays) {
			        setTimeout(handleResize, delay);
			    }
			    /*
			    const observer = new IntersectionObserver((entries, observerInstance) => {
			        for (let entry of entries) {
			            if (entry.isIntersecting) {
			            		alert('IntersectionObserver');
			                adjustFormWidth();
			                observerInstance.unobserve(parentDiv);  // Stop observing once adjusted
			            }
			        }
			    });
			    observer.observe(parentDiv);
			    */
			});
   	 	/*
			const observer = new MutationObserver(function(mutationsList, observer) {
			    for(let mutation of mutationsList) {
			        if (mutation.type === 'childList') {
			        		alert("debugWidth 3");
			            adjustFormWidth();
			        }
			    }
			});
			*/
/*
   	 	function debugWidth() {
   	 		alert("debugWidth 2");
   	 		handleResize();
   	 	}
			setTimeout(debugWidth, 1500);
			*/
   	 	document.addEventListener("visibilitychange", handleVisibilityChange);

	    if (isSignInWithEmailLink(auth, window.location.href)) {
		    // The URL has an email link sign-in. Initialize FirebaseUI to handle it.

		    showAuthUI = true;
		    console.log("isSignInWithEmailLink");
		    tick().then(() => {
		    	console.log("isSignInWithEmailLink 2");
		      ui.start('#firebaseui-auth-container', uiConfig);
		      console.log("isSignInWithEmailLink 3");
		    });
		  }

	    const unsubscribeAuth = onAuthStateChanged(auth, (authUser) => {
	        if (authUser) {
	            user = authUser;
	            //console.log("Auth");
	            //console.log(user);
	            /*
// Closed beta logic
const urlParams = new URLSearchParams(window.location.search);
token = urlParams.get('token');

if (token) {
    (async () => {
      try {
        await validateToken();
      } catch (error) {
        console.error("Error validating token:", error);
      }
    })();
  }
  */

	            isAnonymous = user ? user.isAnonymous : true;
	            //console.log("isAnonymous: "+isAnonymous);
	            if(isAnonymous) {
	            	anonymousUid = auth.currentUser.uid;

	            	if(showAuthUI) {
	            		// should be coming from login flow
	            		// download existing chats. It'll probably finish after new email user gets created, so need some kind of mechanism to handle that. Like, onReturn, do merge
	            		(async () => {
	            				await serializeData();
	            		})();
	            	}
	            } else {
	            	 // trying a delay
	            		/*console.log("delaying logged in user");
	            sleep(2000);  // Blocks for 1 second
	            		console.log("delaying logged in user 2"); */
	            }

	            (async () => {

	            	try {
			            const userDocRef = doc(db, 'users', user.uid);
			            // NOTE: When user logs in, there is a race condition because auth state gets triggered twice. The first time seems to be usually in middle of running this query, and the security rule gets triggered because uid has changed.
			            // I think just handling error is enough
									const userDocSnap = await getDoc(userDocRef);

									pageLoading = false;
									if (userDocSnap.exists()) {
											dbUser = { uid: userDocSnap.id, ...userDocSnap.data() };


									    userAccepted = userDocSnap.data().acceptedWarning;
									    
									    // closed beta:
									    if(userDocSnap.data().accessToken) {
									    	//hasAccess = true;
									    }
									    // end closed beta
									    
									} else {
										userAccepted = false;
									}
								} catch (error) {
								   console.error("Error fetching user document:", error);
								   // Handle the error accordingly
								}

		        	})();
/*
	            // Listen for real-time updates to chats related to the user session
	            const userChatsCollection = collection(db, "chats", user.uid, "userChats");
	            const qChats = query(userChatsCollection, orderBy("lastUpdated", "desc"));
	            
	            const unsubscribeChatsSnapshot = onSnapshot(qChats, (querySnapshot) => {
	            	*/
	            // Listen for real-time updates to chats related to the user session
							const userChatsCollection = collection(db, "chats", user.uid, "userChats");
							// Check if isTemp is either false or not present
							const qChats = query(
							    userChatsCollection,
							    where("isTemp", "==", false), // Check if isTemp is false
							    orderBy("isTemp"), // Use isTemp as the first argument to orderBy
							    orderBy("lastUpdated", "desc") // Order by lastUpdated as the second argument
							);

							/* NOTE: There may be a problem during things like login because auth gets called multiple times
								unsubscribeChatsSnapshot prolly needs to get called in that case. But everything seems to work
								ok so I'm not worrying about it
								*/
							const unsubscribeChatsSnapshot = onSnapshot(qChats, (querySnapshot) => {
							    let previousChatIds;
							    if(!reloadChats) {
							   		previousChatIds = chats.map(chat => chat.id); // Store the previous chat IDs
							   	} else {
							   		reloadChats = false;
							   		previousChatIds = [];
							   	}

							    chats = querySnapshot.docs.map(doc => {
							        const data = doc.data();
							        let userName = null;
							        if(data.userName) {
							        	userName = data.userName;
							        }
							        let userBio = null;
							        if(data.userBio) {
							        	userBio = data.userBio;
							        }
							        let narrativeSpeed = null;
							        if(data.narrativeSpeed) {
							        	narrativeSpeed = data.narrativeSpeed;
							        }
							        return {
							            id: doc.id,  // Include the chat's ID
							            title: data.title,
							            profilePicUrl: data.profilePicUrl,
							            timestamp: data.timestamp.toDate(),
							            userName: userName,
							            userBio: userBio,
							            narrativeSpeed: narrativeSpeed,
							            currStory: data.currStory

							        };
							    });

							    // Find the new chat IDs
							    const newChatIds = chats.map(chat => chat.id).filter(id => !previousChatIds.includes(id));

							    // If there are new chat IDs, log them or take other actions
							    if (newChatIds.length > 0) {
							        //console.log("New chat IDs:", newChatIds);
							        // For simplicity, we're just logging the first new chat ID here
							        const newChatId = newChatIds[0];
							        //console.log("The ID of the new chat is:", newChatId);
							        currentChatId = newChatId;
							        loadMessagesForChat(currentChatId); 
							        // You can add any other logic here, like showing a notification to the user
							    }
							});

				            
				            // listen for a tempChat
							const qTempChats = query(
							    userChatsCollection,
							    where("isTemp", "==", true), // Check if isTemp is false
							    orderBy("isTemp"), // Use isTemp as the first argument to orderBy
							);

							const unsubscribeTEMPChatsSnapshot = onSnapshot(qTempChats, (querySnapshot) => {
								//console.log("qTempChats 1");
							    var tempChats = querySnapshot.docs.map(doc => {
							        const data = doc.data();
							        return {
							            id: doc.id,  // Include the chat's ID
							            title: data.title,
							            profilePicUrl: data.profilePicUrl,
							            hasStory: data.hasStory,
							            tempError: data.tempError,
							            isNsfw: data.isNsfw,
							            timestamp: data.timestamp.toDate(),
							            currStory: data.currStory,
							        };
							    });
							   // console.log("qTempChats 2");
							   // console.log(tempChats);

							    // somehow during the reload of a new one the old one is flickering
							    if(tempChats && tempChats.length > 0) {
							    	currTempChat = tempChats[0];
							    	if(currTempChat.tempError) {
							    		// delete em
							    		deleteTemporaryChats(true);
							    		

							    		
							    	}
							    } else if(currTempChat && activatingTempChat) {
							    	//console.log("activateChat completed.");
							    	currTempChat = null;
							    	activatingTempChat = false;
							    	closeChatModal();

							    	 if (!localStorage.getItem('tipShown')) {
						           showTip = true;
						       	 }
							    }

							});
							


	            return () => {
	                unsubscribeChatsSnapshot();
	                unsubscribeTEMPChatsSnapshot();
	            };
	        } else {
	            signInAnonymously(auth);
	        }
	    });

			// signin stuff
			if (!firebaseui.auth.AuthUI.getInstance()) {
	      ui = new firebaseui.auth.AuthUI(auth);
	    } else {
	      ui = firebaseui.auth.AuthUI.getInstance();
	    }



	    // end signin stuff
			
			// When the component mounts, add overflow-hidden to the body
	    document.body.style.overflow = 'hidden';
	    //console.log("adding class to body");
	    document.body.classList.add('bg-gray-800'); 

	    //console.log("Overflow hidden");
				
			  return () => {
			  };


	    return () => {
	    	  document.removeEventListener("visibilitychange", handleVisibilityChange);
	        unsubscribeAuth();

	        document.body.style.overflow = '';
	        document.body.classList.remove('bg-gray-800');
	        if(ui) {
	        	ui.delete();
	        }
	    };
	});

//closed beta logics

async function validateToken() {
  try {
    console.log("validateToken 1");
    const tokenDocRef = doc(db, 'accessTokens', token);
    if (!tokenDocRef) {
      throw new Error("Token document reference not found");
    }

    const tokenSnap = await getDoc(tokenDocRef);
    console.log("validateToken 2");
    if (tokenSnap.exists()) {
      const usageCount = tokenSnap.data().usageCount || 0;

      if (usageCount < 5000) {
        await updateDoc(tokenDocRef, { usageCount: usageCount + 1 });

        const userDocRef = doc(db, 'users', user.uid); // Ensure user.uid is available and not undefined
        if (!userDocRef) {
          throw new Error("User document reference not found");
        }
				
				console.log("validateToken set access token");
				// this seems dodgy, like it redirects sometimes before accessToken is set.
        await setDoc(userDocRef, { accessToken: token });
        window.location.href = '/';
      } else {
       // await deleteDoc(tokenDocRef);
      }
    }
  } catch (error) {
    console.error("Error in validateToken function:", error);
  }
}
async function requestAccess() {
  if (requestEmail) {
    // Add the email to the Firestore "emails" collection
    const emailsCollection = collection(db, 'emails');
    await addDoc(emailsCollection, { email: requestEmail });

    // Show success message by updating the reactive variable
    isRequestEmailSuccess = true;
    console.log("show isRequestEmailSuccess");
  }
}




	let readyForMerge = false;
	let showWelcome = false;
	function closeWelcome() {
		showWelcome = false;
	}
	// more signin stuff
  const uiConfig = {
    //signInSuccessUrl: '/', // Adjust this to where you want to redirect after login
    signInOptions: [
      {
        provider: EmailAuthProvider.PROVIDER_ID,
        signInMethod: EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
        emailLinkSignIn: function() {
          return {
            //url: window.location.href,  // This should be the URL where FirebaseUI is initialized.
            // You can also set other parameters, such as:
             handleCodeInApp: true,
          };
        },
        requireDisplayName: false
      },
      // Add other providers if needed
    ],
    credentialHelper: firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM,
    callbacks: {
      signInSuccessWithAuthResult: (authResult, redirectUrl) => {
      	console.log('User successfully signed in!');
      	//console.log(authResult);
      	//console.log(redirectUrl);

      	const newUser = authResult.user; // This is the user from the email link sign-in

  			const newUid = newUser.uid;

			  // Now, link the anonymous credential to the new user
			 // if(anonymousUid) {
				  
				   //console.log("Now link the accounts: "+anonymousUid+" with "+newUid);
				   // start by setting user.isAccepted
				  // try {
				   		//alert("merge user 1");
  			//console.log("signin 1, newUID: "+newUid);
							const userDocRef = doc(db, 'users', newUid);
				//console.log("signin 2, anonymousUid: "+anonymousUid);
							//alert("merge user 2");
							setDoc(userDocRef, { 
								acceptedWarning: true,
								anonUID: anonymousUid
								 });
				//console.log("signin 3");
							//alert("merge user 3");
						    userAccepted = true;
						    showAuthUI = false;
						    showWelcome = true;
						    readyForMerge = true;

						    //console.log("setting logged in dbUser");
						     getDoc(userDocRef).then(userDocSnap => {
				//console.log("signin 4");
						        if (userDocSnap.exists()) {
						            dbUser = { uid: userDocSnap.id, ...userDocSnap.data() };
						        } else {
						            console.error("User not found");
						        }
						    }).catch(error => {
						        console.error("Error getting user document:", error);
						    });
						    
				//console.log("deserializeData");
						    deserializeData();
						    //return false; 
					//	} catch (error) {
					    //console.error("Error merge user:", error);
					   // alert("There was a problem merging your old account.");
					//  }
				   // then transfer over chats
			//	}
      	//alert("test 1");
        
				//alert("merge user 3");

        return false; // Return type determines whether we continue the redirect automatically
      },
      signInFailure: (error) => {
      	alert("There was a problem signing you in.");
        if (error.code !== 'firebaseui/anonymous-upgrade-merge-conflict') {
          return Promise.resolve();
        }

        const credential = error.credential;
        return handleMergeConflict(credential);
      }
    },
    // NEED THIS SOON
    //tosUrl: '<your-tos-url>', // Replace with your Terms of Service URL
    //privacyPolicyUrl: '<your-privacy-policy-url>' // Replace with your Privacy Policy URL
  };

  async function toggleAuthUI() {
    showAuthUI = !showAuthUI;
    if (showAuthUI) {
	    await tick();  // Wait for the DOM update
	    ui.start('#firebaseui-auth-container', uiConfig);
	  }
  }

  function handleMergeConflict(credential) {
  	// For a merge conflict, we can retrieve the credential and, for instance, ask the user what to do
  	alert("There was a problem signing in. Please try again.");
  }

  function logout() {
  		toggleDbUser();
	    signOut(auth).then(() => {
	        console.log("User signed out");
	        resetMsgs();
	    }).catch((error) => {
	        console.error("Error signing out: ", error);
	    });
	}

	let prevUserData;
	async function serializeData() {
    try {
    	//console.log("serializeData");
      const serializeFunction = httpsCallable(functions, 'serializeUserData');
      const result = await serializeFunction();
      prevUserData = result.data;

      //console.log(result.data);
      deserializeData();

    } catch (error) {
      console.error('Error serializing data:', error);
    }
  }

  async function deserializeData() {
    try {
    	//console.log("deserializeData");
    	if(prevUserData && readyForMerge) {
    		//console.log("deserializeData BEGIN");
    		readyForMerge = false;

	      const deserializeFunction = httpsCallable(functions, 'deserializeUserData');
	      const result = await deserializeFunction({ serializedData: prevUserData });
	      
	      //console.log("deserializeData FINISH");
	      //console.log(result.data);
	    }
    } catch (error) {
      console.error('Error deserializing data:', error);
    }
  }
	// end signin stuff

	function handleVisibilityChange() {
      isHidden = document.hidden;
      if (!isHidden) {
      		//console.log("handleVisibilityChange: visible");
          checkForNewMessages();
      }
  }

  function checkForNewMessages() { 
      const now = new Date();
      if(currentChatId && !isHidden && latestMessageTimestamp) {
	      if ((now - latestMessageTimestamp) >= (12 * 60 * 60 * 1000)) { // There are no new messages in the past 12 hours   
      		//if ((now - latestMessageTimestamp) >= (1 * 60 * 60 * 1000)) { // 1 hour
      	//	if ((now - latestMessageTimestamp) >= (1 * 30 * 60 * 1000)) { // 30 minutes
	           welcomeBackMsg();
			
	      }
	    }
  }

  function getFtime() {
  	const now = new Date();

		const options = {
		    weekday: 'long',
		    year: 'numeric',
		    month: 'long',
		    day: 'numeric',
		    hour: '2-digit',
		    minute: '2-digit',
		    hour12: true
		};

		const formattedTime = new Intl.DateTimeFormat('en-US', options).format(now);
		const timeParts = formattedTime.split(', ');
		const datePart = timeParts.slice(0, 3).join(', ');
		const timePart = timeParts[3].replace(' AM', ' A.M.').replace(' PM', ' P.M.');

		const fCurrTime = `${datePart} at ${timePart}`;

		return fCurrTime;
  }

  async function welcomeBackMsg() {
  	//console.log("welcomeBackMsg");
  	 const now = new Date();
     const timeDifference = latestMessageTimestamp ? now - latestMessageTimestamp.getTime() : 0;
		 
		 const welcomeBackMsgFn = httpsCallable(functions, 'welcomeBackMsg');
			const result = await welcomeBackMsgFn({ chatId: currentChatId, timeDifference: timeDifference, fCurrTime: getFtime() });
  }

	async function deleteTemporaryChats(showError) {
	  const delTempChats = httpsCallable(functions, 'delTempChats');
	  try {
	    const result = await delTempChats({});
	    
	    if(showError) {
	    	currTempChat = null;
		    //console.log("delTempChats completed.");
		    alert('There was a problem creating the role. Please try again.');
	    	closeChatModal();

	    }
	  } catch (error) {
	    console.error("Error delTempChats:", error);
	  }
	}

	function getAbbr(msgData, currChatRecord) {
		//console.log("getAbbr");
		if(currChatRecord) {
			if(msgData.isAutomated || msgData.isAction) {
				if(!msgData.isAction) {
					return currChatRecord.title.charAt(0);
				} else {
					return "☆"; // Narrator
				}
			} else {
				return "U";
			}
		}
	}

	let currentUnsubscribe; // Store the current unsubscribe function
	let finalAutomatedId = null;
	let currChatTitle = appTitle;
	let prevNumMsgs = 0;
	let isRefreshing = null;
	

	function resetMsgs() {
		isMsgInProgress = false;
	    isSidebarOpen = false;
	    isRefreshing = null;
	    messages = [];
	    latestMessageTimestamp = null;

	    if (currentUnsubscribe) {
	        currentUnsubscribe();
	    }
	}

	let currChatRecord;
	function loadMessagesForChat(chatId) {
	    currentChatId = chatId;
	    resetMsgs();

	    currChatRecord = chats.find(chat => chat.id === currentChatId);
	    currChatTitle = currChatRecord.title;

	    

	    const userMessagesCollection = collection(db, "messages", user.uid, "userMessages");
	    const q = query(userMessagesCollection, where("chatId", "==", chatId), orderBy("timestamp", "asc"));
	    currentUnsubscribe = onSnapshot(q, (querySnapshot) => {

	         messages = querySnapshot.docs.map(doc => ({
		        id: doc.id,
		        abbr: getAbbr(doc.data(), currChatRecord),
		        ...doc.data()
		    	 }));

		    	 //console.log("num messages: "+messages.length);
		    	
	        let foundRefreshMsg = false;
	        prevNotAutomated = null;
	        let prevNotAutomatedFound = false;
	        messages.forEach((message) => {
		         	if(message.isAutomated) {
		         		if(prevNotAutomatedFound) {
		         //	} && !(message.isImage || message.isAction || message.firstTime || message.welcomeBackTimeDiff)) {
		         			finalAutomatedId = message.id;
		         			prevNotAutomatedFound = false;
		         		}
		         		
		         	} else {
		         		prevNotAutomated = message;
		         		prevNotAutomatedFound = true;
		         	}
		         	if(isRefreshing && isRefreshing == message.id) {
		         		foundRefreshMsg = true;
		         		//console.log("Found refresh msg");
		         	}

					});

					 if(isRefreshing && !foundRefreshMsg) {
		    	 		isRefreshing = null;
		    	 		//console.log("Refresh done, reset refresh btn");

		    	 }
		    	 prevNumMsgs = messages.length;

	        if (messages.length > 0) {
	            latestMessageTimestamp = messages[messages.length - 1].timestamp?.toDate();
	           // console.log("Loading message checkForNewMessages: "+messages.length+" - "+latestMessageTimestamp);
	            checkForNewMessages();
	        }

	        // NEED TO check if last message timestamp is recently. Also somehow set timer to disable after a bit
	        checkInProgress();
	        scrollToBottom();
	    });
	}

  
	let isAction = false;
	async function addMessage() {
	    if (user && newMessage.trim() !== "" && currentChatId && !isMsgInProgress) {
	    		let tempNewMessage = newMessage;
	    		newMessage = "";

	    		
	    		/*
	    		if (tempNewMessage.toLowerCase().includes("action:")) { 
	    			tempNewMessage = tempNewMessage.replace(/action:/gi, '');

	    			isAction = true;
	    		}
	    		*/

	        const userMessagesCollection = collection(db, "messages", user.uid, "userMessages");
	        await addDoc(userMessagesCollection, {
	            content: tempNewMessage,
	            timestamp: serverTimestamp(),
	            isAction: isAction,
	            chatId: currentChatId
	        });
	        
	        isMsgInProgress = true;

	      
	    }
	}

	async function createNewChat(isNsfw) {
		currTempChat = null;
		showCreateChat2 = false;
		isCreatingChat = true;
		
	    try {
	    		let presetTxt = null;
	    		let presetGenTxt = null;
	    		if(thisPreset) {
	    			presetTxt = thisPreset.txt;
	    			presetGenTxt = thisPreset.genTxt;
	    		}
	        const result = await createChatFunction({ isNsfw: isNsfw, isMale: createIsMale, presetTxt: presetTxt, presetGenTxt: presetGenTxt });
	        // function returns too late
	        //currentChatId = result.data.chatId;
	        logEvent(analytics, 'create_chat');
	        //console.log("chat created.");
	    } catch (error) {
	        console.error("Error creating new chat:", error);
	    }
	    
	}

	let showTryAgain
	function customChatInProcess() {
    console.log('Custom chat in process...');
    // ... rest of your code
    customCharacter = false;
    currTempChat = null;
		showCreateChat2 = false;
		isCreatingChat = true;
  }

	async function reloadCreateChat(isNsfw) {
		currTempChat = null;
	    createNewChat(isNsfw); 
	}

	let activatingTempChat = false;
	async function activateTempChat() {
		if(currTempChat && currTempChat.id) {
			//console.log("activateChat begun.");

			activatingTempChat = true;
	    	const activateChat = httpsCallable(functions, 'activateChat');

	    	const result = await activateChat({ chatId: currTempChat.id, currStory: currTempChat.currStory });
			
		    
		    // wait until db is updated to close modal
		    // closeChatModal();
			  
		} else {
			//console.log("Error activating chat.");
			alert('There was a problem creating the role. Please try again.');
			closeChatModal();
		}
	}

	
/*
	async function createNewChat() {
	    if (user) {
	        const userChatsCollection = collection(db, "chats", user.uid, "userChats");
	        const docRef = await addDoc(userChatsCollection, {
	            title: "Madi",
	            timestamp: serverTimestamp()
	        });
	        currentChatId = docRef.id;
	    }
	}
	*/


	function checkInProgress() {
		
		const finalMessage = messages[messages.length - 1];
		if(finalMessage && finalMessage.inProcess) {
			if(!isMsgInProgress) {
				//console.log("Message in progress");
			}
			isMsgInProgress = true;
		} else {
			if(isMsgInProgress) {
				//console.log("Message NOT in progress");
			}
			isMsgInProgress = false;
		}

	}

  function addMessageDirect(event) {
        if (event.key === 'Enter' || event.keyCode === 13) {
            // Prevent the default action (newline) from occurring
            event.preventDefault();

            // Your logic here
            //console.log('Enter key was pressed!');
            addMessage();
        }
    }

    let isDeletingChat = false;
    async function deleteChat(chatId) {
    	const userResponse = confirm("Are you sure you want to delete this persona?");

			if (userResponse) {
				isDeletingChat = true;
				reloadChats = true;
				const deleteChatFn = httpsCallable(functions, 'deleteChat');
				const result = await deleteChatFn({ chatId: chatId });
				isDeletingChat = false;

				//currChatRecord = null;
			}
    }

    function addMessageBtn(event) {
    	event.preventDefault(); // Prevent default behavior
    	//console.log('addMessageBtn pressed!');
        addMessage();
    }

    async function refreshMsg(messageId) {
    	//console.log("refreshMsg: "+messageId);

    	isRefreshing = messageId;
    	const refreshMsgFn = httpsCallable(functions, 'refreshMsg');
			const result = await refreshMsgFn({ chatId: currentChatId, messageId: messageId, prevIsAction: prevNotAutomated.isAction })
			
    }

    async function autoMsg() {
    	event.preventDefault();
    	//console.log("autoMsg");
    	if(!isMsgInProgress) {
    		isMsgInProgress = true;
	    	const autoMsgFn = httpsCallable(functions, 'autoMsg');
				const result = await autoMsgFn({ chatId: currentChatId });
			}
			
    }
    

    function formatDate(date) {
	  const options = { year: 'numeric', month: 'short', day: 'numeric' };
	  return date.toLocaleDateString(undefined, options);
	}

    let messagesContainer;

	function scrollToBottom() {
	   
	    if(messagesContainer && !scrolledUp) {
	    	//console.log("scrollToBottom");
	        messagesContainer.scrollTop = messagesContainer.scrollHeight;
	    }
	}

	let lastScrollTop = 0;
	let scrolledUp = false;

	function handleScroll(event) {

		const currentScrollTop = messagesContainer.scrollTop;

		// Check if user scrolls up for the first time
		if (currentScrollTop < lastScrollTop && !scrolledUp) {
		  scrolledUp = true;
		 // console.log("User scrolled up for the first time!");
		}

		// Check if user scrolls back down to the very bottom
		if (currentScrollTop + messagesContainer.clientHeight >= messagesContainer.scrollHeight) {
			scrolledUp = false;
		 // console.log("User scrolled back down to the very bottom!");
		}

		lastScrollTop = currentScrollTop;
	}

	// NOTE: Don't think these need to be inside onMount()
	/*
	  function toggleDarkMode() {
	  	console.log("toggleDarkMode")
	    isDarkMode = !isDarkMode;
	    if (isDarkMode) {
	      document.documentElement.classList.add('dark');
	      localStorage.setItem('dark-mode', 'true');
	    } else {
	      document.documentElement.classList.remove('dark');
	      localStorage.setItem('dark-mode', 'false');
	    }
	  }
	  */

	afterUpdate(scrollToBottom);

	function logMessageExecution() {
        console.log("The image code block was executed.");
    }
/*
  onMount(async () => {
  const querySnapshot = await getDocs(collection(db, "messages"));
  messages = querySnapshot.docs.map(doc => doc.data());
}); */


    let showCreateChat = false;
    let showCreateChat2 = false;
    let createIsMale = false;
    let isCreatingChat = false;

    // {createNewChat}
     function closeChatModal() {
	    
	    customCharacter = false;
	    isSidebarOpen = false;
	    if(currTempChat && currTempChat.id) {
	    	//console.log("closing modal while chat being created.");

	    	const userResponse = confirm("Are you sure you want to proceed?");

			if (userResponse) {
			    showCreateChat = false;
			    showCreateChat2 = false;
		    	isCreatingChat = false;
		    	createIsMale = false;
		    	thisPreset = null;
		    	deleteTemporaryChats(false);
			} else {
			    //console.log("User clicked Cancel");
			}
	    	
	    } else {
	    	showCreateChat2 = false;
	    	showCreateChat = false;
	    	isCreatingChat = false;
	    	createIsMale = false;
	    	thisPreset = null;
	    }
	  }

	  function createChat2(isMale) {
			showCreateChat2 = true;
			createIsMale = isMale;
	  }
/*
	  let presets = [
        { key: 'holly', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetHolly.jpg?alt=media&token=8c34aee3-c70d-4b72-9b9d-89db90dfa9da', txt: 'Name: Holly Golightly, played by a young Audrey Hepburn, portraying the spontaneous and careless young woman in New York City, callgirl.', isMale: false },
        { key: 'leia', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetLeia.jpg?alt=media&token=42fd8692-a5fc-44e0-99cc-dfacdf8adba9', txt: 'Name: Leia, a young Princess Leia in Star Wars.', isMale: false },
        { key: 'buffy', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetBuffy.jpg?alt=media&token=850df422-e619-4297-b56e-2291fc09e2ea', txt: 'Name: Buffy, a young Vampire Slayer.', isMale: false },
        { key: 'daenerys', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetDaenerys.jpg?alt=media&token=d089741f-04c6-46b8-bcbe-2614eb07a868', txt: 'Name: Daenerys Targaryen from Game of Thrones.', isMale: false },
        { key: 'ai', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-ai.jpg?alt=media&token=daf4134f-64d6-4fe8-9cda-55bfba1ebd38', txt: 'Name: Ai, Blonde hair, Tan skin, Toned body with sword scars, Chiseled features, green eyes, Hot Dangerous Ninja Warrior for Good, English-speaking Japanese.', isMale: false },

        { key: 'aamod', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-aamodel.jpg?alt=media&token=d85d9ed5-de89-4f25-88fd-bee8792d273f', txt: null, genTxt:'skinny black model', isMale: false },

        { key: 'swed', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-influencer.jpg?alt=media&token=8a392137-9c86-45a0-a5db-b61d2fa50b80', txt: null, genTxt:'sexy blonde skinny female with blue eyes from Sweden enjoying her life as a traveling, sporty social media influencer', isMale: false },

        { key: 'aafull', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-aafull.jpg?alt=media&token=dbc92a6e-8efc-4666-bfd2-a8c596d27f66', txt: null, genTxt:'full figured attractive black woman', isMale: false },

        { key: 'japanese', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-japanese.jpg?alt=media&token=1bf26103-f3c4-477b-bfbb-acf66036f25b', txt: null, genTxt:'cute young Japanese-American woman', isMale: false },

    ];
    */
let presets = [
  /*{
    category: 'Closed-Beta Presets',
    items: [
      { key: 'holly', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetHolly.jpg?alt=media&token=8c34aee3-c70d-4b72-9b9d-89db90dfa9da', txt: 'Name: Holly Golightly, played by a young Audrey Hepburn, portraying the spontaneous and careless young woman in New York City, callgirl.', isMale: false },
        { key: 'leia', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetLeia.jpg?alt=media&token=42fd8692-a5fc-44e0-99cc-dfacdf8adba9', txt: 'Name: Leia, a young Princess Leia in Star Wars.', isMale: false },
        { key: 'buffy', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetBuffy.jpg?alt=media&token=850df422-e619-4297-b56e-2291fc09e2ea', txt: 'Name: Buffy, a young Vampire Slayer.', isMale: false },
        { key: 'daenerys', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/presetDaenerys.jpg?alt=media&token=d089741f-04c6-46b8-bcbe-2614eb07a868', txt: 'Name: Daenerys Targaryen from Game of Thrones.', isMale: false },
      // Add more items in this category
    ]
  }, */
  {
    category: 'Adventure Presets',
    items: [
      { key: 'ninja', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-ai.jpg?alt=media&token=daf4134f-64d6-4fe8-9cda-55bfba1ebd38', txt: null, genTxt:'Blonde hair, Tan skin, Toned body with sword scars, Chiseled features, green eyes, Attractive Dangerous Ninja Warrior for Good, English-speaking Japanese.', isMale: false },
      { key: 'astronautfemale', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-astronautfemale.jpg?alt=media&token=0d700c2d-9dc5-4fe3-b419-492a5c45c737', txt: null, genTxt:'attractive female astronaut on Mars', isMale: false },
      { key: 'bowhuntress', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-bowhuntress.jpg?alt=media&token=4bbfd8ec-d5f2-4d65-8681-3de653a50e1e', txt: null, genTxt:'Dark chestnut hair, Bronze skin, Whiplike physique with archery calluses, Aquiline nose, Pensive walnut eyes, Skilled Bow Huntress, Grecian', isMale: false },
      { key: 'icemage', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-icemage.jpg?alt=media&token=73a44d0d-7cdf-4a13-8c49-37e57732dc74', txt: null, genTxt:'Platinum hair, Icy-blue skin, Sleek figure with aurora borealis patterns, Ethereal features, Luminous turquoise eyes, Mighty Ice Mage, Norse', isMale: false },
      { key: 'oceanadventurer', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-oceanadventurer.jpg?alt=media&token=7e633610-b855-4d4f-9fce-39fd1877be27', txt: null, genTxt:'Cascading sandy hair, Sunburned skin, Solid build with surfing scars, Sun-kissed features, Sparkling teal eyes, Fearless Ocean Adventurer, Polynesian', isMale: false },
      { key: 'piratewoman', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-piratewoman.jpg?alt=media&token=711adcee-d791-41d7-832d-73519c7c2934', txt: null, genTxt:'Auburn hair, Pale skin, Curvy physique with inked tattoos, Strong jawline, Deep-set blue eyes, Cunning Pirate Captain, British', isMale: false },
      { key: 'russiaspy', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-russiaspy.jpg?alt=media&token=7bdb0b53-f76a-4a05-be88-d4784a104c05', txt: null, genTxt:'Brunette hair, Tawny skin, Balanced build with elegant dancer\'s grace, Refined features, Captivating dark brown eyes, Defiant Revolutionary Spy, Russian', isMale: false },
      { key: 'templedefender', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-templedefender.jpg?alt=media&token=4907a4ef-bae4-403b-8c65-102576964c3b', txt: null, genTxt:'Lustrous dark hair, Caramel skin, Voluptuous figure with ancient runes, Broad forehead, Engaging onyx eyes, Sacred Temple Defender, Indian', isMale: false },
     /* { key: '', img: '', txt: null, genTxt:'', isMale: false }, */


      { key: 'alchemist', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-alchemist.jpg?alt=media&token=8b121546-f64f-4f52-a8c2-b35e17a2daf7', txt: null, genTxt:'Slick raven hair, Marble white skin, Slender with alchemical burns, Enigmatic face, Burning crimson eyes, Alchemist of the Forbidden, Renaissance Italy', isMale: true },
      { key: 'bullfighter', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-bullfighter.jpg?alt=media&token=803100d5-4365-445d-9171-7d301bc7c938', txt: null, genTxt:'Flowing golden hair, Caramel skin, Flamboyant physique with matador mementos, Handsome demeanor, Charismatic brown eyes, Fearless Bullfighter, Spanish', isMale: true },
      { key: 'desertarcher', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-desertarcher.jpg?alt=media&token=841d2558-e3d6-4295-8c72-0be2167fd4ae', txt: null, genTxt:'Turbulent wavy hair, Bronze skin, Medium build with archer\'s grace, Stubbled chin, Watchful green eyes, Silent Desert Archer, Middle Eastern', isMale: true },
      { key: 'icemagemale', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-icemagemale.jpg?alt=media&token=d7c1c260-61a1-4e10-b837-c09a4a2e6eca', txt: null, genTxt:'Snow-white hair, Cracked ice skin, Frosty physique with icicle adornments, Glacial face, Arctic sapphire eyes, Ice Mage of the North, Polar Kingdoms', isMale: true },
      { key: 'mysticwarlock', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-mysticwarlock.jpg?alt=media&token=5616bc39-bffe-4cfc-9f09-0566e8578976', txt: null, genTxt:'Bald, Alabaster skin, Herculean build with arcane sigils, Broad nose, Glowing golden eyes, Ancient Mystic Warlock, Old European', isMale: true },
      { key: 'savannawarrior', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-savannawarrior.jpg?alt=media&token=bf8ebe55-b623-4d58-a187-2fff3dd0ebe3', txt: null, genTxt:'Ebony dreadlocks, Deep brown skin, Sculpted physique with lion motifs, Strong brow, Fierce amber eyes, Noble Savanna Warrior, African Plains', isMale: true },
     /* { key: '', img: '', txt: null, genTxt:'', isMale: true },
      { key: '', img: '', txt: null, genTxt:'', isMale: true },
      { key: '', img: '', txt: null, genTxt:'', isMale: true }, */
    ]
  },
  {
    category: 'Ethinicity Presets',
    items: [
      { key: 'aamod', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-aamodel.jpg?alt=media&token=d85d9ed5-de89-4f25-88fd-bee8792d273f', txt: null, genTxt:'skinny black model', isMale: false },

        { key: 'swed', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-influencer.jpg?alt=media&token=8a392137-9c86-45a0-a5db-b61d2fa50b80', txt: null, genTxt:'sexy blonde skinny female with blue eyes from Sweden enjoying her life as a traveling, sporty social media influencer', isMale: false },

        { key: 'aafull', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-aafull.jpg?alt=media&token=dbc92a6e-8efc-4666-bfd2-a8c596d27f66', txt: null, genTxt:'full figured attractive black woman', isMale: false },

        { key: 'japanese', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-japanese.jpg?alt=media&token=1bf26103-f3c4-477b-bfbb-acf66036f25b', txt: null, genTxt:'cute young Japanese-American woman', isMale: false },

        { key: 'latina', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-latina.jpg?alt=media&token=b9cb81b2-af77-44ca-a9db-2cf577b62ce4', txt: null, genTxt:'an attractive latina woman', isMale: false },


        { key: 'aamale', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-aamale.jpg?alt=media&token=3be61c01-41ec-426a-98aa-16a34712e0a0', txt: null, genTxt:'an attractive black man', isMale: true },

        { key: 'asianmale', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-asianmale.jpg?alt=media&token=ca4fb0a7-0ce1-49ec-aa94-ca1f4521603c', txt: null, genTxt:'an attractive asian man', isMale: true },
        { key: 'latinomale', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-latinomale.jpg?alt=media&token=52724760-46c1-41cc-8aa3-fd74636b8e09', txt: null, genTxt:'an attractive latino man', isMale: true },
        { key: 'whitemale', img: 'https://firebasestorage.googleapis.com/v0/b/playful-ce174.appspot.com/o/preset-whitemale.jpg?alt=media&token=d336e65c-4a43-4720-ad3d-1fd79a65ae2f', txt: null, genTxt:'an attractive white man', isMale: true },
        /*
        { key: '', img: '', txt: null, genTxt:'', isMale: true },
        { key: '', img: '', txt: null, genTxt:'', isMale: true },
        { key: '', img: '', txt: null, genTxt:'', isMale: true },
        
				*/
      // Add more items in this category
    ]
  },
  // Add more categories here
];


  	let thisPreset;
		/*function setPreset(key) {
        //console.log('Preset Key:', key);
        thisPreset = presets.find(p => p.key === key);

        //console.log(thisPreset);
        createIsMale = thisPreset.isMale;
        showCreateChat2 = true;

    }*/
    function setPreset(key) {
			  //console.log('Preset Key:', key);
			  thisPreset = null;

			  // Find the preset within categories
			  for (const category of presets) {
			    const preset = category.items.find(p => p.key === key);
			    if (preset) {
			      thisPreset = preset;
			      break;
			    }
			  }

			  if (thisPreset) {
			    //console.log(thisPreset);
			    createIsMale = thisPreset.isMale;
			    showCreateChat2 = true;
			  }
		}

	  async function acceptWarning() {
  		const user = auth.currentUser;
		  if (user) {
				const userDocRef = doc(db, 'users', user.uid);
				await setDoc(userDocRef, { 
					acceptedWarning: true,
					acceptedTimestamp: serverTimestamp(),
					 });

				//console.log("set acceptWarning dbUser");
				const updatedUserDocSnap = await getDoc(userDocRef);

			  if (updatedUserDocSnap.exists()) {
			    dbUser = { uid: updatedUserDocSnap.id, ...updatedUserDocSnap.data() };
			  }
		    userAccepted = true;

		    showCreateChat = true;

		    logEvent(analytics, 'accept_warning');
		  }
	}

	let isSidebarOpen = false;  // Sidebar toggle state for mobile view

	  function toggleSidebar() {
	    isSidebarOpen = !isSidebarOpen;
	  }

	  let isTipsOpen = false;
	  function toggleTips() {
	  	isTipsOpen = !isTipsOpen;
	  }

	  function openFbForm() {
	  	//console.log("openFbForm");
	    isFbFormOpen = true;
	  }
	  function closeFbForm() {
	    isFbFormOpen = false;
	  }

	  const toggleDbUser = () => {
	  	//console.log("toggleDbUser: "+dbUser.uid);

	    editingDbUser = !editingDbUser;
	  };
	  
	  const handleDbUserUpdate = (event) => {
	    //console.log("handleDbUserUpdate");
	    //console.log(event.detail);
	    dbUser = { ...event.detail };
	  };

	  let isEditingChat = false;
	  const toggleEditChat = () => {
	  	//console.log("toggleEditChat: "+dbUser.uid);

	    isEditingChat = !isEditingChat;
	  };

	  const handleChatUpdate = (event) => {
	    //console.log("handleChatUpdate");
	    //console.log(event.detail);
	    currChatRecord = { ...event.detail };
	  };

	  const handleDeleteChat = (event) => {
	  	toggleEditChat();
	    deleteChat(event.detail);
	  };

	   let placeholderText = "Enter your message";
    let isAutoSelected = false;
    function handleSelectChange(event) {
        if (event.target.value === "Action") {
            placeholderText = "Enter an action or narration";
            isAutoSelected = false;
            isAction = true;
        } else if (event.target.value === "Auto") {
            isAutoSelected = true;
            isAction = false;
        } else {
            placeholderText = "Enter your message";
            isAutoSelected = false;
            isAction = false;
        }
    }

    function showPrivacyPolicy() {
    	//console.log("showPrivacyPolicy");
	    showPrivacyModal = true;
	  }

	  function closePrivacyPolicy() {
	    showPrivacyModal = false;
	  }

	  function showTermsOfUse() {
	    showTermsModal = true;
	  }

	  function closeTermsOfUse() {
	    showTermsModal = false;
	  }

	  let isStoryExpanded = false;

	  function toggleStoryExpand() {
	    isStoryExpanded = !isStoryExpanded;
	  }

	  let customCharacter = false;
	  function showCustomCharacter() {
	  	customCharacter = true;
	  }

	  const urlParams = new URLSearchParams(window.location.search);

  const tryDeb = urlParams.get("tryDeb") === "t";

let strokeWidth = 0.4;
  //console.log('Firebase App:', app);
	//console.log('Firebase Auth:', auth);
</script>

<style>
	
	.flex.h-screen {
	    overflow: hidden;
	}
	.messages {
    overflow-y: auto;
    height: calc(100vh - HEIGHT_OF_TOP_BAR - HEIGHT_OF_BOTTOM_FORM);
}
@supports (-webkit-touch-callout: none) {
  .h-screen {
    height: -webkit-fill-available;
  }
}
</style>


<!--{#if hasAccess || userAccepted}-->
{#if hasAccess}

<LoadingModal {pageLoading} />
{#if user}
    <Notification uid={user.uid} />
{/if}

{#if isMobile}
  <!-- Top bar for mobile -->
  <style>
	  /* Define a custom class for a smaller left margin */
	  .ml-custom {
	    margin-left: 0.09rem; /* You can adjust the margin size as needed */
	  }
	</style>
	<div class="fixed top-0 left-0 right-0 flex justify-start items-center bg-gray-800 p-1 z-10">
	    <button on:click={toggleSidebar} class="p-2">
	        <svg 
	            xmlns="http://www.w3.org/2000/svg"
	            class="h-9 w-9 text-blue-600 ml-custom"
	            fill="#BBBBBB"
	            stroke-width="1"
	            viewBox="0 0 20 20"
	            style="vertical-align: middle;"
	        >
	            <path d="M10,1.445c-4.726,0-8.555,3.829-8.555,8.555c0,4.725,3.829,8.555,8.555,8.555c4.725,0,8.555-3.83,8.555-8.555C18.555,5.274,14.725,1.445,10,1.445 M10,17.654c-4.221,0-7.654-3.434-7.654-7.654c0-4.221,3.433-7.654,7.654-7.654c4.222,0,7.654,3.433,7.654,7.654C17.654,14.221,14.222,17.654,10,17.654 M14.39,10c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,9.55,14.39,9.752,14.39,10 M14.39,12.702c0,0.247-0.203,0.449-0.45,0.449H6.06c-0.248,0-0.45-0.202-0.45-0.449c0-0.248,0.203-0.451,0.45-0.451h7.879C14.187,12.251,14.39,12.454,14.39,12.702 M14.39,7.298c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,6.848,14.39,7.051,14.39,7.298"></path>
	        </svg>
	    </button>
	    <span class="text-[#BBBBBB] ml-2 absolute left-1/2 transform -translate-x-1/2">{currChatTitle}</span>
	</div>

{/if}
{#if isSidebarOpen && isMobile}
  <div 
    class="fixed top-0 left-0 w-full h-full bg-black opacity-70 z-10" on:click={toggleSidebar} 
  ></div>
{/if}

<div class="flex h-screen">
  <!-- Sidebar -->
 	<aside class={`flex h-full w-60 ${isMobile ? isSidebarOpen ? 'fixed top-0 left-0 inset-0 z-50' : 'hidden fixed top-0 left-0 inset-0 z-50' : ""} sm:flex sm:block`}>

  <div
    class="flex h-[100svh] w-60 flex-col overflow-y-auto bg-slate-50 pt-8 dark:border-slate-700 dark:bg-slate-900 sm:h-[100vh] sm:w-64"
  >
    
  	{#if isMobile }
  		<div class="flex items-center">
  <button on:click={toggleSidebar} class="p-3 -mt-8">
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      class="h-9 w-9 text-blue-600 ml-custom"
      fill="#BBBBBB"
      stroke-width="1"
      viewBox="0 0 20 20"
      style="vertical-align: middle;"
    >
      <path d="M10,1.445c-4.726,0-8.555,3.829-8.555,8.555c0,4.725,3.829,8.555,8.555,8.555c4.725,0,8.555-3.83,8.555-8.555C18.555,5.274,14.725,1.445,10,1.445 M10,17.654c-4.221,0-7.654-3.434-7.654-7.654c0-4.221,3.433-7.654,7.654-7.654c4.222,0,7.654,3.433,7.654,7.654C17.654,14.221,14.222,17.654,10,17.654 M14.39,10c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,9.55,14.39,9.752,14.39,10 M14.39,12.702c0,0.247-0.203,0.449-0.45,0.449H6.06c-0.248,0-0.45-0.202-0.45-0.449c0-0.248,0.203-0.451,0.45-0.451h7.879C14.187,12.251,14.39,12.454,14.39,12.702 M14.39,7.298c0,0.248-0.203,0.45-0.45,0.450H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,6.848,14.39,7.051,14.39,7.298"></path>
    </svg>
  </button>
  <span class="text-[#BBBBBB] -mt-8">{appTitle}</span>

  <div class="ml-auto bg-blue-950  h-auto max-h-8 rounded-full px-1 pt-1.5 pb-1 -mt-8 mr-3">
  	<a href="https://twitter.com/playfully_ai" target="_blank">
		  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="22px" height="22px"  aria-labelledby="unique-id-123">
		  	<title id="unique-id-123">Playfully AI Twitter</title> 

		    <path d="M28,6.937c-0.957,0.425-1.985,0.711-3.064,0.84c1.102-0.66,1.947-1.705,2.345-2.951c-1.03,0.611-2.172,1.055-3.388,1.295 c-0.973-1.037-2.359-1.685-3.893-1.685c-2.946,0-5.334,2.389-5.334,5.334c0,0.418,0.048,0.826,0.138,1.215 c-4.433-0.222-8.363-2.346-10.995-5.574C3.351,6.199,3.088,7.115,3.088,8.094c0,1.85,0.941,3.483,2.372,4.439 c-0.874-0.028-1.697-0.268-2.416-0.667c0,0.023,0,0.044,0,0.067c0,2.585,1.838,4.741,4.279,5.23 c-0.447,0.122-0.919,0.187-1.406,0.187c-0.343,0-0.678-0.034-1.003-0.095c0.679,2.119,2.649,3.662,4.983,3.705 c-1.825,1.431-4.125,2.284-6.625,2.284c-0.43,0-0.855-0.025-1.273-0.075c2.361,1.513,5.164,2.396,8.177,2.396 c9.812,0,15.176-8.128,15.176-15.177c0-0.231-0.005-0.461-0.015-0.69C26.38,8.945,27.285,8.006,28,6.937z" fill="#1DA1F2" />
		  </svg>
		</a>
	</div>
</div>


  	{:else}
    	<div class="flex px-4">
	      <!-- Logo -->
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
				     class="h-9 w-9 text-blue-600"
				     fill="currentColor"
				     stroke="currentColor"
				     stroke-width="5"
				     viewBox="0 0 184 236">
				    <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
				    <g>
				        <g>
				            <g>
				                <path d="M170.2,11.6c-2.2,2.2-2,6.3,0.2,8.4c1.7,1.6,2.6,1.7,15.1,1.7h13.2l-16.9,16.9L165,55.5l-4.9-3.2c-7.8-5.1-15.9-7.3-26.2-7.3c-9.7-0.1-15.8,1.2-23.4,5.1c-12.7,6.4-21.2,16.3-25.9,29.9c-2,5.5-2.2,7.3-2.2,16s0.2,10.5,2.2,16c3.9,11.4,10.3,19.8,19.7,26.2c3.3,2.1,6.8,4.1,7.8,4.4c2.3,0.6,5.5-1.3,6.7-4.1c1.3-2.9-0.2-5.3-5.9-8.9C95.5,118.6,89.2,97,97.9,79.1c5-10.2,13.4-17.5,24.1-20.8c4.5-1.3,6.8-1.6,13.4-1.3c7.2,0.3,8.6,0.6,14,3.2c30.2,14.4,30.9,55.4,1.2,70.9c-6.2,3.2-7,4.1-7,7.8c0,2.6,3.1,5.5,5.9,5.5c3.1,0,12.8-5.5,18-10.4c7.9-7.3,13.3-16.2,15.5-25.7c1.3-5.9,1.5-17.6,0.3-23.4c-0.9-4.1-5.4-14.5-8.3-18.8l-1.4-2.1l16.4-16.4c9-9.1,16.6-16.4,17-16.4c0.4,0,0.6,5.9,0.6,13.1c0,12.7,0.1,13.2,1.8,14.8c2.6,2.4,6.3,2.3,8.3-0.3c1.6-2,1.6-3,1.6-23.4s-0.1-21.3-1.6-23.4l-1.6-2h-22.3C172.8,10,171.7,10.1,170.2,11.6z"/>
				                <path d="M63.6,81.6c-8.2,4.4-17.2,13.6-21.4,22.1c-7.4,15.2-7.4,31,0,46.1c2.6,5.2,4.7,8,9.6,12.9c8.3,8.2,15.5,12,28,14.8l2.1,0.5v14v14l-12,0.3c-10.5,0.2-12.3,0.4-13.7,1.7c-2.5,2.3-2.3,6.9,0.4,9c1.9,1.5,3.1,1.6,13.7,1.6h11.6v11.6c0,10.5,0.2,11.8,1.6,13.7c2,2.6,6.2,2.8,8.5,0.5c1.4-1.4,1.6-2.6,1.6-13.7v-12.1H105c12.5,0,14.6-0.5,16.1-4.1c0.8-1.9,0.8-2.7-0.2-4.4c-2-3.4-4.1-4-16.1-4H93.6V192V178l2.2-0.4c5.9-1.2,15.5-4.8,19.8-7.7c9.7-6.4,16.8-15.5,20.8-26.5c2.7-7.5,3.3-20.2,1.3-28.4c-3.2-14-13.4-27.3-25.8-33.5c-3.4-1.8-4.4-2-6.2-1.3c-2.8,1.1-4.2,3-4.3,5.6c0,2.6,1.9,4.6,6.4,7c7.7,3.9,15.6,14.7,18.2,24.5c4.5,17.3-4.3,36.2-20.5,44.3c-15.9,8-33.7,4.8-45.7-7.8c-5.9-6.2-8.7-11.6-10.4-19.3c-1.4-6.8-1.4-8.8,0-15.6c2.5-11.8,10.2-22,20.4-27c7.6-3.8,9.3-7.4,5.4-11.3C72.7,78,70,78.3,63.6,81.6z"/>
				            </g>
				        </g>
				    </g>
				</svg>

			  
			  <h2 class="px-4 text-lg font-medium text-slate-800 dark:text-slate-200 flex items-center">
	   
	        {appTitle}
	        
	      </h2>

		      <div class="ml-auto bg-blue-950  h-auto max-h-8 rounded-full px-1 pt-1.5 pb-1 mt-1">
		      	<a href="https://twitter.com/playfully_ai" target="_blank">
						  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="22px" height="22px"  aria-labelledby="unique-id-123">
						  	<title id="unique-id-123">Playfully AI Twitter</title> 

						    <path d="M28,6.937c-0.957,0.425-1.985,0.711-3.064,0.84c1.102-0.66,1.947-1.705,2.345-2.951c-1.03,0.611-2.172,1.055-3.388,1.295 c-0.973-1.037-2.359-1.685-3.893-1.685c-2.946,0-5.334,2.389-5.334,5.334c0,0.418,0.048,0.826,0.138,1.215 c-4.433-0.222-8.363-2.346-10.995-5.574C3.351,6.199,3.088,7.115,3.088,8.094c0,1.85,0.941,3.483,2.372,4.439 c-0.874-0.028-1.697-0.268-2.416-0.667c0,0.023,0,0.044,0,0.067c0,2.585,1.838,4.741,4.279,5.23 c-0.447,0.122-0.919,0.187-1.406,0.187c-0.343,0-0.678-0.034-1.003-0.095c0.679,2.119,2.649,3.662,4.983,3.705 c-1.825,1.431-4.125,2.284-6.625,2.284c-0.43,0-0.855-0.025-1.273-0.075c2.361,1.513,5.164,2.396,8.177,2.396 c9.812,0,15.176-8.128,15.176-15.177c0-0.231-0.005-0.461-0.015-0.69C26.38,8.945,27.285,8.006,28,6.937z" fill="#1DA1F2" />
						  </svg>
						</a>
					</div>


	    </div>
	  {/if}
    
    <div class="mx-2 mt-8">
      <button
	    on:click={() => showCreateChat = true}
	    class="flex w-full gap-x-4 rounded-lg border border-slate-300 p-4 text-left text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-slate-200 focus:outline-none dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
	>
	    <svg
	      xmlns="http://www.w3.org/2000/svg"
	      class="h-5 w-5"
	      viewBox="0 0 24 24"
	      stroke-width="2"
	      stroke="currentColor"
	      fill="none"
	      stroke-linecap="round"
	      stroke-linejoin="round"
	    >
	      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
	      <path d="M12 5l0 14"></path>
	      <path d="M5 12l14 0"></path>
	    </svg>
	    New Persona
	</button>

    </div>
    <!-- Previous chats container -->
	<div
	  class="h-2/3 space-y-4 overflow-y-auto border-b border-slate-300 px-2 py-4 pb-16 dark:border-slate-700"
	>
	  
	  {#each chats as chat (chat.timestamp)}  <!-- Add a key for each loop -->
	  	{#if currentChatId === chat.id }
	  			<div
    class="flex w-full flex-col gap-y-2 rounded-lg px-3 py-2 text-left transition-colors duration-200 
    {currentChatId === chat.id ? 'bg-slate-100 dark:bg-slate-750' : ''} "
    tabindex="0"
>
    <div class="flex items-center justify-between gap-x-2">
        <!-- Profile picture and title grouped together -->
        <div class="flex items-center gap-x-2">
            <img 
                src="{chat.profilePicUrl}" 
                alt="Profile Image" 
                class="w-12 h-12 rounded-full border border-slate-300 dark:border-slate-700" 
            />

            <h1
                class="text-md font-medium capitalize text-slate-700 dark:text-slate-200"
            >
                {chat.title}
            </h1>
        </div>
       <!-- <svg class="svg-icon" style="width: 1em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M801.781896 303.530015 724.525348 303.530015c26.63359-12.279674 43.516096-32.209586 41.24231-66.526159-3.243881-48.976458-46.635133-78.720899-101.158934-78.720899-49.377594 0-107.884103 24.934902-153.971767 82.807984-46.087665-57.873082-104.595196-82.500992-153.97279-82.500992-54.523801 0-97.915054 29.387307-101.158934 78.363765-2.272763 34.316573 14.609743 54.29765 41.24231 66.577325L221.560118 303.531038c-44.199665 0-81.846076 37.464263-81.846076 81.663928l0 72.027453c0 11.04966 10.773368 18.22406 21.823028 18.22406l313.821405 0L475.358475 311.429939c16.372899-1.920746 23.586185-3.958148 33.20117-5.861498 9.103332 1.802042 23.080671 3.723811 31.267121 5.553483l0 164.323533 321.977155 0c11.04966 0 17.760502-7.1744 17.760502-18.22406l0-72.027453C879.564423 340.994278 845.981561 303.530015 801.781896 303.530015zM664.609747 214.712153c4.451382 0 43.533492 0.75213 45.25981 26.810622 0.12689 1.918699 0.280386 6.535857-1.038656 7.944949-0.541329 0.578168-13.905708 14.151301-71.370491 14.151301-22.552645 0-45.99659-2.102894-67.403133-4.948709C601.776699 227.148393 636.848473 214.712153 664.609747 214.712153zM311.405379 241.522776c1.725294-26.058492 40.808428-26.810622 45.25981-26.810622l0 0c27.768437 0 62.84942 12.440333 94.576005 43.980677-21.35947 2.833535-44.791136 4.925173-67.426669 4.925173-57.464783 0-70.829162-13.573133-71.370491-14.151301C311.124993 248.058632 311.278489 243.442498 311.405379 241.522776z"  /><path d="M167.343309 785.346575c0 44.199665 38.027082 78.955236 82.226746 78.955236l225.788419 0 0-368.390231-308.015166 0L167.343309 785.346575z"  /><path d="M539.826765 864.301811l229.942019 0c44.199665 0 78.073146-34.755572 78.073146-78.955236L847.841931 495.91158l-308.015166 0L539.826765 864.301811z"  /></svg> -->

        {#if isDeletingChat }
  						<svg
							    xmlns="http://www.w3.org/2000/svg"
							    class="h-11 w-10 flex-none p-2 -mr-2 "
							    viewBox="0 0 24 24"
							    fill="none"
							    stroke="white"
							    stroke-width="2"
							    stroke-linecap="round"
							    stroke-linejoin="round"
							    style="animation: slow-spin 2s linear infinite;"
							>
							    <circle cx="12" cy="12" r="10" stroke-opacity=".3"></circle>
							    <path d="M22 12 L18 12"></path>
							    <path d="M6 12 L2 12"></path>
							    <path d="M12 6 L12 2"></path>
							    <path d="M12 22 L12 18"></path>
							</svg>
				{:else}
		        <button class="h-8 w-8 relative hover:stroke-2 transition-stroke duration-200"
		        	on:click={() => toggleEditChat(chat.id)} 
		        	on:mouseover={() => strokeWidth = 0.8}
		        	on:mouseout={() => strokeWidth = 0.4}
		        	title="Edit Persona"
		        >
		        	<svg class="h-8 w-8 absolute  bottom-[-4px]"
					          viewBox="0 0 24 24"
					          width="32" height="32" 
					          stroke-width={strokeWidth}
					          stroke="white"
					          fill="none"
					          stroke-linecap="round"
					          stroke-linejoin="round">
								<path d="M17.498,11.697c-0.453-0.453-0.704-1.055-0.704-1.697c0-0.642,0.251-1.244,0.704-1.697c0.069-0.071,0.15-0.141,0.257-0.22c0.127-0.097,0.181-0.262,0.137-0.417c-0.164-0.558-0.388-1.093-0.662-1.597c-0.075-0.141-0.231-0.22-0.391-0.199c-0.13,0.02-0.238,0.027-0.336,0.027c-1.325,0-2.401-1.076-2.401-2.4c0-0.099,0.008-0.207,0.027-0.336c0.021-0.158-0.059-0.316-0.199-0.391c-0.503-0.274-1.039-0.498-1.597-0.662c-0.154-0.044-0.32,0.01-0.416,0.137c-0.079,0.106-0.148,0.188-0.22,0.257C11.244,2.956,10.643,3.207,10,3.207c-0.642,0-1.244-0.25-1.697-0.704c-0.071-0.069-0.141-0.15-0.22-0.257C7.987,2.119,7.821,2.065,7.667,2.109C7.109,2.275,6.571,2.497,6.07,2.771C5.929,2.846,5.85,3.004,5.871,3.162c0.02,0.129,0.027,0.237,0.027,0.336c0,1.325-1.076,2.4-2.401,2.4c-0.098,0-0.206-0.007-0.335-0.027C3.001,5.851,2.845,5.929,2.77,6.07C2.496,6.572,2.274,7.109,2.108,7.667c-0.044,0.154,0.01,0.32,0.137,0.417c0.106,0.079,0.187,0.148,0.256,0.22c0.938,0.936,0.938,2.458,0,3.394c-0.069,0.072-0.15,0.141-0.256,0.221c-0.127,0.096-0.181,0.262-0.137,0.416c0.166,0.557,0.388,1.096,0.662,1.596c0.075,0.143,0.231,0.221,0.392,0.199c0.129-0.02,0.237-0.027,0.335-0.027c1.325,0,2.401,1.076,2.401,2.402c0,0.098-0.007,0.205-0.027,0.334C5.85,16.996,5.929,17.154,6.07,17.23c0.501,0.273,1.04,0.496,1.597,0.66c0.154,0.047,0.32-0.008,0.417-0.137c0.079-0.105,0.148-0.186,0.22-0.256c0.454-0.453,1.055-0.703,1.697-0.703c0.643,0,1.244,0.25,1.697,0.703c0.071,0.07,0.141,0.15,0.22,0.256c0.073,0.098,0.188,0.152,0.307,0.152c0.036,0,0.073-0.004,0.109-0.016c0.558-0.164,1.096-0.387,1.597-0.66c0.141-0.076,0.22-0.234,0.199-0.393c-0.02-0.129-0.027-0.236-0.027-0.334c0-1.326,1.076-2.402,2.401-2.402c0.098,0,0.206,0.008,0.336,0.027c0.159,0.021,0.315-0.057,0.391-0.199c0.274-0.5,0.496-1.039,0.662-1.596c0.044-0.154-0.01-0.32-0.137-0.416C17.648,11.838,17.567,11.77,17.498,11.697 M16.671,13.334c-0.059-0.002-0.114-0.002-0.168-0.002c-1.749,0-3.173,1.422-3.173,3.172c0,0.053,0.002,0.109,0.004,0.166c-0.312,0.158-0.64,0.295-0.976,0.406c-0.039-0.045-0.077-0.086-0.115-0.123c-0.601-0.6-1.396-0.93-2.243-0.93s-1.643,0.33-2.243,0.93c-0.039,0.037-0.077,0.078-0.116,0.123c-0.336-0.111-0.664-0.248-0.976-0.406c0.002-0.057,0.004-0.113,0.004-0.166c0-1.75-1.423-3.172-3.172-3.172c-0.054,0-0.11,0-0.168,0.002c-0.158-0.312-0.293-0.639-0.405-0.975c0.044-0.039,0.085-0.078,0.124-0.115c1.236-1.236,1.236-3.25,0-4.486C3.009,7.719,2.969,7.68,2.924,7.642c0.112-0.336,0.247-0.664,0.405-0.976C3.387,6.668,3.443,6.67,3.497,6.67c1.75,0,3.172-1.423,3.172-3.172c0-0.054-0.002-0.11-0.004-0.168c0.312-0.158,0.64-0.293,0.976-0.405C7.68,2.969,7.719,3.01,7.757,3.048c0.6,0.6,1.396,0.93,2.243,0.93s1.643-0.33,2.243-0.93c0.038-0.039,0.076-0.079,0.115-0.123c0.336,0.112,0.663,0.247,0.976,0.405c-0.002,0.058-0.004,0.114-0.004,0.168c0,1.749,1.424,3.172,3.173,3.172c0.054,0,0.109-0.002,0.168-0.004c0.158,0.312,0.293,0.64,0.405,0.976c-0.045,0.038-0.086,0.077-0.124,0.116c-0.6,0.6-0.93,1.396-0.93,2.242c0,0.847,0.33,1.645,0.93,2.244c0.038,0.037,0.079,0.076,0.124,0.115C16.964,12.695,16.829,13.021,16.671,13.334 M10,5.417c-2.528,0-4.584,2.056-4.584,4.583c0,2.529,2.056,4.584,4.584,4.584s4.584-2.055,4.584-4.584C14.584,7.472,12.528,5.417,10,5.417 M10,13.812c-2.102,0-3.812-1.709-3.812-3.812c0-2.102,1.71-3.812,3.812-3.812c2.102,0,3.812,1.71,3.812,3.812C13.812,12.104,12.102,13.812,10,13.812"></path>
						</svg>
					   <!-- delete icon <svg class="h-6 w-6"
					          viewBox="0 0 24 24"
					          stroke-width={strokeWidth}
					          stroke="white"
					          fill="none"
					          stroke-linecap="round"
					          stroke-linejoin="round">
					        <path d="M17.114,3.923h-4.589V2.427c0-0.252-0.207-0.459-0.46-0.459H7.935c-0.252,0-0.459,0.207-0.459,0.459v1.496h-4.59c-0.252,0-0.459,0.205-0.459,0.459c0,0.252,0.207,0.459,0.459,0.459h1.51v12.732c0,0.252,0.207,0.459,0.459,0.459h10.29c0.254,0,0.459-0.207,0.459-0.459V4.841h1.511c0.252,0,0.459-0.207,0.459-0.459C17.573,4.127,17.366,3.923,17.114,3.923M8.394,2.886h3.214v0.918H8.394V2.886z M14.686,17.114H5.314V4.841h9.372V17.114z M12.525,7.306v7.344c0,0.252-0.207,0.459-0.46,0.459s-0.458-0.207-0.458-0.459V7.306c0-0.254,0.205-0.459,0.458-0.459S12.525,7.051,12.525,7.306M8.394,7.306v7.344c0,0.252-0.207,0.459-0.459,0.459s-0.459-0.207-0.459-0.459V7.306c0-0.254,0.207-0.459,0.459-0.459S8.394,7.051,8.394,7.306"></path>
			    		</svg> -->
						</button>
				{/if}
    </div>
</div>


	  	{:else}
	    <button
		    on:click={() => loadMessagesForChat(chat.id)}  
		    class="flex w-full flex-col gap-y-2 rounded-lg px-3 py-2 text-left transition-colors duration-200 
		    {currentChatId === chat.id ? 'bg-slate-100 dark:bg-slate-750' : ''} hover:bg-slate-200 focus:outline-none dark:hover:bg-slate-800"
		>
		    <div class="flex items-center gap-x-2">
		        <!-- Profile picture -->
		        <img 
		            src="{chat.profilePicUrl}" 
		            alt="Profile Image" 
		            class="w-12 h-12 rounded-full border border-slate-300 dark:border-slate-700" 
		        />

		        <h1
		            class="text-md font-medium capitalize text-slate-700 dark:text-slate-200"
		        >
		            {chat.title}
		            
		        </h1>
		    </div>
		    
		</button>
			{/if}
	  {/each}




	</div>
	<div class="mt-auto w-full space-y-2 px-2 py-4">
		<button
        class="flex items-center font-light w-full gap-x-2 rounded-lg px-3 py-2 text-left text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-slate-200 focus:outline-none dark:text-slate-200 dark:hover:bg-slate-800"
        on:click={openFbForm}
      >  
  				<svg 
  					class="h-6 w-6" 
  					viewBox="0 0 20 20"
  					stroke-width="0.5"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          >
							<path d="M18.303,4.742l-1.454-1.455c-0.171-0.171-0.475-0.171-0.646,0l-3.061,3.064H2.019c-0.251,0-0.457,0.205-0.457,0.456v9.578c0,0.251,0.206,0.456,0.457,0.456h13.683c0.252,0,0.457-0.205,0.457-0.456V7.533l2.144-2.146C18.481,5.208,18.483,4.917,18.303,4.742 M15.258,15.929H2.476V7.263h9.754L9.695,9.792c-0.057,0.057-0.101,0.13-0.119,0.212L9.18,11.36h-3.98c-0.251,0-0.457,0.205-0.457,0.456c0,0.253,0.205,0.456,0.457,0.456h4.336c0.023,0,0.899,0.02,1.498-0.127c0.312-0.077,0.55-0.137,0.55-0.137c0.08-0.018,0.155-0.059,0.212-0.118l3.463-3.443V15.929z M11.241,11.156l-1.078,0.267l0.267-1.076l6.097-6.091l0.808,0.808L11.241,11.156z"></path>
						</svg>
  					Feedback
		</button>
		<button
        class="flex items-center font-light w-full gap-x-2 rounded-lg px-3 py-2 text-left text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-slate-200 focus:outline-none dark:text-slate-200 dark:hover:bg-slate-800"
        on:click={toggleTips}
      >
        <svg 

 class="h-6 w-6"
          stroke-width="30"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"

         style="overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M623.6 831.6H399.3c-16.6 0-30-13.5-30-30V724c-30.4-20.7-56.1-47.8-75.1-79.4-22.7-37.6-35.2-80.8-36.3-124.9-0.9-35.6 5.6-70.2 19.2-103 13-31.5 32-59.7 56.4-83.8 24.4-24.1 52.8-42.8 84.4-55.6 32.9-13.2 67.6-19.3 103.2-18.1 66.1 2.2 127.9 29.7 174 77.3 46.2 47.7 71.7 110.6 71.7 177 0 45.6-12.2 90.4-35.4 129.5-19.4 32.8-46.1 60.9-77.7 82.1v76.6c-0.1 16.4-13.6 29.9-30.1 29.9z m-194.3-60h164.3v-63.2c0-10.8 5.8-20.7 15.1-26.1 60.4-34.6 97.9-99.3 97.9-168.8 0-105.4-82.4-190.7-187.7-194.3-53.9-1.8-104.8 18.2-143.3 56.4-38.5 38.2-59.1 88.8-57.8 142.7 1.6 67.9 37.7 128.9 96.5 163.3h0.1c9.2 5.4 14.8 15.3 14.8 25.9v64.1z m194.3-63.3zM215.5 535.8h-100c-13.3 0-24-10.7-24-24s10.7-24 24-24h100c13.3 0 24 10.7 24 24s-10.8 24-24 24zM255.9 386.1c-4.1 0-8.3-1.1-12.1-3.3l-86.3-50.5c-11.4-6.7-15.3-21.4-8.6-32.8 6.7-11.4 21.4-15.3 32.8-8.6l86.3 50.5c11.4 6.7 15.3 21.4 8.6 32.8-4.4 7.6-12.4 11.9-20.7 11.9zM362.5 279.5c-8.2 0-16.3-4.2-20.7-11.9l-50.5-86.3c-6.7-11.4-2.9-26.1 8.6-32.8 11.4-6.7 26.1-2.9 32.8 8.6l50.5 86.3c6.7 11.4 2.9 26.1-8.6 32.8-3.8 2.3-8 3.3-12.1 3.3zM512.2 239c-13.3 0-24-10.7-24-24V115c0-13.3 10.7-24 24-24s24 10.7 24 24v100c0 13.3-10.7 24-24 24zM662 279.5c-4.1 0-8.3-1.1-12.1-3.3-11.4-6.7-15.3-21.4-8.6-32.8l50.5-86.3c6.7-11.4 21.4-15.3 32.8-8.6 11.4 6.7 15.3 21.4 8.6 32.8l-50.5 86.3c-4.5 7.7-12.5 11.9-20.7 11.9zM768.5 386.1c-8.2 0-16.3-4.2-20.7-11.9-6.7-11.4-2.9-26.1 8.6-32.8l86.3-50.5c11.4-6.7 26.1-2.9 32.8 8.6 6.7 11.4 2.9 26.1-8.6 32.8l-86.3 50.5c-3.8 2.2-7.9 3.3-12.1 3.3zM909 535.8H809c-13.3 0-24-10.7-24-24s10.7-24 24-24h100c13.3 0 24 10.7 24 24s-10.7 24-24 24zM562.2 925.6h-100c-16.6 0-30-13.4-30-30s13.4-30 30-30h100c16.6 0 30 13.4 30 30s-13.4 30-30 30z" fill="#000002" /></svg>
        Tips
    </button>
		<!-- clsed beta -->
	{#if user && !isAnonymous}
	<button
        class="flex items-center font-light w-full gap-x-2 rounded-lg px-3 py-2 text-left text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-slate-200 focus:outline-none dark:text-slate-200 dark:hover:bg-slate-800"
        on:click={toggleDbUser}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
          <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
          <path
            d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"
          ></path>
        </svg>
        Settings
    </button>
	{:else}
		<button
        class="flex items-center font-light w-full gap-x-2 rounded-lg px-3 py-2 text-left text-sm font-medium text-slate-700 transition-colors duration-200 hover:bg-slate-200 focus:outline-none dark:text-slate-200 dark:hover:bg-slate-800"
        on:click={toggleAuthUI}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
          <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
          <path
            d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"
          ></path>
        </svg>
        Sign In
    </button>
	{/if}

</div>

{#if showAuthUI}
		

		<div class="fixed inset-0 w-screen h-screen flex items-center justify-center z-50">
		  <!-- Background overlay -->
		  <div class="absolute inset-0 bg-black opacity-70"></div>

		  <div class="relative w-[600px] h-[95vh] max-h-[95vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto overflow-x-hidden">

		  <div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
		  			<div class="ml-auto">
		            <p 
		                class="rounded-full text-base font-semibold leading-5 text-gray-400 hover:text-white cursor-default"
		                on:click={toggleAuthUI}
		            >
		                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
		            </p>
		        </div>
		        <div class="absolute top-20 left-1/2 transform -translate-x-1/2">

		      		<div id="firebaseui-auth-container" class="w-[300px]"></div>
		      	</div>
		    </div>



		  </div>
{/if}

  </div>
</aside>

<div class="flex flex-grow flex-col relative" id="parentDiv">


  <div
  	bind:this={messagesContainer} on:scroll={handleScroll} 
  	style="padding-top: {isMobile ? '4rem' : '0'}; padding-bottom: 4.75rem;"

    class="flex-1 overflow-y-auto bg-slate-300 text-sm leading-6 text-slate-900 shadow-md dark:bg-slate-800 dark:text-slate-300 sm:text-base sm:leading-7 pt-safe-top pb-safe-bottom "
  >
  {#if currChatRecord && currChatRecord.currStory }
  	<div class="flex bg-slate-100 px-4 py-8 dark:bg-slate-900 sm:px-6">    
				<RoundIcon
				  label="☆"
				  bgColor="bg-blue-950"
				  textColor="text-white"
				  size="h-8 w-8"
				  padding="p-2"
				  margin="mr-4"  
				/>
				
				<div class="flex w-full flex-col items-start relative">
				  <div
				    class="flex-grow relative max-w-3xl overflow-hidden"
				    class:line-clamp-2={!isStoryExpanded}
				  >
				    <p>{currChatRecord.currStory}</p>
				  </div>
				  {#if !isStoryExpanded}
				    <button
				      class="text-blue-500 underline mt-2 cursor-pointer"
				      on:click={toggleStoryExpand}
				    >
				      More
				    </button>
				  {/if}
				  {#if isStoryExpanded}
				    <button
				      class="text-blue-500 underline mt-2 cursor-pointer"
				      on:click={toggleStoryExpand}
				    >
				      Less
				    </button>
				  {/if}
				</div>

		</div>

  {/if}
  {#each messages as message}
	  {#if message.isAutomated || message.isImage || message.isAction}
	  		<div class="flex bg-slate-100 px-4 py-8 dark:bg-slate-900 sm:px-6">
	          
	        {#if message.isAction}
							<RoundIcon
							  label="{message.abbr}"
							  bgColor="bg-blue-950"
							  textColor="text-white"
							  size="h-8 w-8"
							  padding="p-2"
							  margin="mr-4"  
							/>
					{:else}
							<RoundIcon
							  label="{message.abbr}"
							  bgColor="bg-blue-500"
							  textColor="text-white"
							  size="h-8 w-8"
							  padding="p-2"
							  margin="mr-4"  
							/>
					{/if}

					<div class="flex w-full flex-col items-start lg:flex-row lg:justify-between relative">

          {#if message.isError}
          		<p class="max-w-3xl">
                  Error: <MessageContent message={message.errorMsg} />
              </p>
          {:else if message.isImage}
						  {#if !imageLoaded[message.imgUrl]}
							    <div class="text-lg font-medium">
							        <LoadingSpinner message="{message.statusMsg} " />
							    </div>
						  {/if}
						    
						  {#if message.imgUrl && message.imgUrl.trim() !== ''}
						    	<div class="relative w-full max-w-screen-md h-auto">
								    <img 
								        src={message.imgUrl} 
								        alt="Inline Image" 
								        class="max-w-full h-auto"
								        on:loadstart={() => imageLoaded[message.imgUrl] = true}
								        on:load={() => imageLoaded[message.imgUrl] = true}
								    />
									</div>
							{/if}
	        {:else}	
          			{#if message.id == finalAutomatedId } 
	          			<div class="flex-grow relative max-w-3xl pr-10">
	          				<MessageContent message={message.content} />
	          			</div>
          			{:else}
	          			<div class="flex-grow relative max-w-3xl">
	          				<MessageContent message={message.content} />
	          			</div>
          			{/if}
				        
				        <!-- NOTE: When mkaing this better, only put button on final automated message. Cuz too easy to delete entire conversation -->
				        {#if message.id == finalAutomatedId}
				        			{#if isRefreshing }
				        						<svg
														    xmlns="http://www.w3.org/2000/svg"
														    class="absolute top-0 right-0 h-8 w-7 flex-none"
														    viewBox="0 0 24 24"
														    fill="none"
														    stroke="currentColor"
														    stroke-width="2"
														    stroke-linecap="round"
														    stroke-linejoin="round"
														    style="animation: slow-spin 2s linear infinite;"
														>
														    <circle cx="12" cy="12" r="10" stroke-opacity=".3"></circle>
														    <path d="M22 12 L18 12"></path>
														    <path d="M6 12 L2 12"></path>
														    <path d="M12 6 L12 2"></path>
														    <path d="M12 22 L12 18"></path>
														</svg>
											{:else}
										        <button class="absolute top-0 right-0 ml-4 text-white p-2 rounded-full hover:bg-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:ring-opacity-50" 
											        on:click={() => refreshMsg(message.id)} 
											        title="Refresh response" >					        	
										           <svg xmlns="http://www.w3.org/2000/svg"
													    class="h-6 w-6 text-blue-600"
													    fill="none"
													    stroke="currentColor"
													    stroke-width="0.5" viewBox="0 0 20 20">
														<path d="M12.319,5.792L8.836,2.328C8.589,2.08,8.269,2.295,8.269,2.573v1.534C8.115,4.091,7.937,4.084,7.783,4.084c-2.592,0-4.7,2.097-4.7,4.676c0,1.749,0.968,3.337,2.528,4.146c0.352,0.194,0.651-0.257,0.424-0.529c-0.415-0.492-0.643-1.118-0.643-1.762c0-1.514,1.261-2.747,2.787-2.747c0.029,0,0.06,0,0.09,0.002v1.632c0,0.335,0.378,0.435,0.568,0.245l3.483-3.464C12.455,6.147,12.455,5.928,12.319,5.792 M8.938,8.67V7.554c0-0.411-0.528-0.377-0.781-0.377c-1.906,0-3.457,1.542-3.457,3.438c0,0.271,0.033,0.542,0.097,0.805C4.149,10.7,3.775,9.762,3.775,8.76c0-2.197,1.798-3.985,4.008-3.985c0.251,0,0.501,0.023,0.744,0.069c0.212,0.039,0.412-0.124,0.412-0.34v-1.1l2.646,2.633L8.938,8.67z M14.389,7.107c-0.34-0.18-0.662,0.244-0.424,0.529c0.416,0.493,0.644,1.118,0.644,1.762c0,1.515-1.272,2.747-2.798,2.747c-0.029,0-0.061,0-0.089-0.002v-1.631c0-0.354-0.382-0.419-0.558-0.246l-3.482,3.465c-0.136,0.136-0.136,0.355,0,0.49l3.482,3.465c0.189,0.186,0.568,0.096,0.568-0.245v-1.533c0.153,0.016,0.331,0.022,0.484,0.022c2.592,0,4.7-2.098,4.7-4.677C16.917,9.506,15.948,7.917,14.389,7.107 M12.217,15.238c-0.251,0-0.501-0.022-0.743-0.069c-0.212-0.039-0.411,0.125-0.411,0.341v1.101l-2.646-2.634l2.646-2.633v1.116c0,0.174,0.126,0.318,0.295,0.343c0.158,0.024,0.318,0.034,0.486,0.034c1.905,0,3.456-1.542,3.456-3.438c0-0.271-0.032-0.541-0.097-0.804c0.648,0.719,1.022,1.659,1.022,2.66C16.226,13.451,14.428,15.238,12.217,15.238"></path>
													</svg>

										        </button>
										  {/if}
					     	{/if}

	        {/if}
	                
	        </div>

	            
			
	    </div>
      <!-- debug -->
      {#if tryDeb}
      	<div class="w-full mt-4 text-xs">
<pre class="whitespace-pre-wrap">
var fullTxt = `{message.promptTxt}`;
{#if message.isImage}
-------------------------------------
{message.purePrompt}
-------------------------------------
{message.fullPrompt}
{/if}
_____________________________________
</pre>
	    </div>
	    {/if}
	 <!--		end debug -->
	            
		{:else}
	        <!-- Render this block if message isn't automated -->
	        <div class="flex flex-row px-4 py-8 sm:px-6">
	        	<RoundIcon
							  label="{message.abbr}"
							  bgColor="bg-gray-500"
							  textColor="text-white"
							  size="h-8 w-8"
							  padding="p-2"
							  margin="mr-4"  
							/>
	            <div class="flex max-w-3xl items-center">
	                <p><MessageContent message={message.content} /></p>
	            </div>
	        </div>

	        <!-- debug -->
      {#if tryDeb}
      	<div class="w-full mt-4 text-xs">
<pre class="whitespace-pre-wrap">
var fullTxt = `{message.promptTxt}`;
{#if message.isImage}
-------------------------------------
{message.purePrompt}
-------------------------------------
{message.fullPrompt}
{/if}
_____________________________________
</pre>
	    </div>
	    {/if}
	 <!--		end debug -->
	  {/if}

	{/each}


  </div>

  <!-- Prompt message input -->
  <!--
  <form
    class="flex w-full items-center rounded-b-md border-t border-slate-300 bg-slate-200  py-4 p-2 dark:border-slate-700 dark:bg-slate-900"
  >
-->

<form 
	class="fixed bottom-0 w-full flex items-center rounded-b-md border-t border-slate-300 bg-slate-200 py-4  dark:border-slate-700 dark:bg-slate-900 {isMobile ? 'left-0 p-0' : 'p-2'}" 
	id="fixedForm"
>

<label for="chat" class="sr-only">Enter your prompt</label>

<div class="flex flex-grow items-center mx-2 relative">

    <!-- Step 1: Wrapper div for dropdown and textarea -->
    <div class="flex bg-slate-50 border border-slate-300 dark:border-slate-700 dark:bg-slate-800 rounded-md overflow-hidden flex-grow">

        <style>
.select-styled {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    outline: none;
    box-shadow: none;
    border: none;
    cursor: pointer;
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="%23BBBBBB" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg>');
    background-repeat: no-repeat;
    background-position: right 0.6rem center; /* Adjusted this value to move the arrow to the right */
    background-color: transparent;
    padding-right: 2rem; /* Added padding to ensure text doesn't overlap with the arrow */
    border-right: 1px solid #334155;
}

</style>

<!-- Adjusted Dropdown -->
<select class="flex-shrink-0 w-22 bg-slate-50 dark:bg-slate-800 p-2 text-base text-slate-900 dark:text-slate-300 focus:ring-0 focus:outline-none select-styled" on:change={handleSelectChange}>
    <option value="Response">Reply: </option>
    <option value="Action">Action: </option>
    <option value="Auto">Auto: </option>
</select>

		{#if isAutoSelected}
        <button 
        	class="flex-grow p-2 bg-slate-50 dark:bg-slate-800 text-base text-slate-900 {isMsgInProgress ? 'dark:text-slate-400' : 'dark:text-slate-50'}  focus:outline-none focus:ring-0"
        	on:click={autoMsg}
        >
            Click to auto-generate your response
        </button>
    {:else}
        <!-- Textarea -->
        <textarea
				    bind:value={newMessage} 
				    on:keydown={addMessageDirect}
				    id="chat-input"
				    rows="1"
				    class="flex-grow min-h-full border-0 bg-slate-50 p-2 text-base text-slate-900 placeholder-slate-400 focus:border-none focus:outline-none focus:ring-0 dark:bg-slate-800 dark:text-slate-50 dark:placeholder-slate-400 pr-10" 
				    placeholder={placeholderText}
				></textarea>
			 {/if}
    </div>

    {#if isMsgInProgress}
    <div transition:fade class="absolute right-1 top-1/2">
        <DotsSpinner  />
    </div>
    {:else}
    	{#if !isAutoSelected}
		    <div transition:fade class="absolute right-1 top-1/2">
		        <button
		            on:click={addMessageBtn}
		            class=" transform -translate-y-1/2 inline-flex hover:text-blue-600 dark:text-slate-200 dark:hover:text-blue-600 sm:p-2"
		        >
		            <svg
		                xmlns="http://www.w3.org/2000/svg"
		                class="h-6 w-6"
		                aria-hidden="true"
		                viewBox="0 0 24 24"
		                stroke-width="2"
		                stroke="#475569"
		                fill="none"
		                stroke-linecap="round"
		                stroke-linejoin="round"
		            >
		                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
		                <path d="M10 14l11 -11"></path>
		                <path
		                    d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"
		                ></path>
		            </svg>
		            <span class="sr-only">Send message</span>
		        </button>
		    </div>
		  {/if}
    {/if}

</div>

</form>



<!--
	<form 
		class="fixed bottom-0 w-full flex items-center rounded-b-md border-t border-slate-300 bg-slate-200 py-4 p-2 dark:border-slate-700 dark:bg-slate-900 {isMobile ? 'left-0' : ''}" 
		id="fixedForm"
	>


    <label for="chat" class="sr-only">Enter your prompt</label>
    

	<div class="flex flex-grow items-center mx-2 relative">
		{#if showTip}
        <Tip {showTip} message="Tip: Begin message with 'Action:' to narrate an action." />
    {/if}
		<button class="absolute -left-4 h-10 w-10 bg-slate-800 border border-slate-700 rounded-full text-sm text-slate-400 ml-2 {isMsgInProgress ? 'opacity-50' : 'hover:border-slate-600'}"
			 	on:click={autoMsg}
			 	title="Auto-generate your response"
			 	>Auto</button>
	    <textarea
	        bind:value={newMessage} 
	        on:keydown={addMessageDirect}
	        id="chat-input"
	        rows="1"
	        class="flex-grow min-h-full rounded-md border border-slate-300 bg-slate-50 p-2 text-base text-slate-900 placeholder-slate-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-50 dark:placeholder-slate-400 dark:focus:border-blue-600 dark:focus:ring-blue-600 pr-10 ml-10" 
	        placeholder="Enter your message"
	    ></textarea>

	    {#if isMsgInProgress}
			<div transition:fade class="absolute right-1 top-1/2">
	  			<DotsSpinner  />
	  		</div>
			{:else}

		    <div transition:fade class="absolute right-1 top-1/2">
			    <button
			        on:click={addMessageBtn}
			        class=" transform -translate-y-1/2 inline-flex hover:text-blue-600 dark:text-slate-200 dark:hover:text-blue-600 sm:p-2"
			    >
			        <svg
			            xmlns="http://www.w3.org/2000/svg"
			            class="h-6 w-6"
			            aria-hidden="true"
			            viewBox="0 0 24 24"
			            stroke-width="2"
			            stroke="#475569"
			            fill="none"
			            stroke-linecap="round"
			            stroke-linejoin="round"
			        >
			            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			            <path d="M10 14l11 -11"></path>
			            <path
			                d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"
			            ></path>
			        </svg>
			        <span class="sr-only">Send message</span>
			    </button>
		    </div>
			 {/if}
	  
	</div>
	
	  </form>
	-->
	</div>
</div>


{#if showCreateChat}
<div class="fixed inset-0 w-screen h-screen flex items-center justify-center z-50">
  <!-- Background overlay -->
  <div class="absolute inset-0 bg-black opacity-70" on:click={closeChatModal}></div>

  <!-- Modal content -->
  <div class="relative w-[600px] h-[95vh] max-h-[95vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-scroll overflow-x-hidden">

 	<div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10 max-w-screen" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
		
	  <div>

	    <div class="flex items-center gap-x-4">
	    	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
		     class="h-9 w-9 text-blue-600"
		     fill="currentColor"
		     stroke="currentColor"
		     stroke-width="5"
		     viewBox="0 0 184 236">
		    <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
		    <g>
		        <g>
		            <g>
		                <path d="M170.2,11.6c-2.2,2.2-2,6.3,0.2,8.4c1.7,1.6,2.6,1.7,15.1,1.7h13.2l-16.9,16.9L165,55.5l-4.9-3.2c-7.8-5.1-15.9-7.3-26.2-7.3c-9.7-0.1-15.8,1.2-23.4,5.1c-12.7,6.4-21.2,16.3-25.9,29.9c-2,5.5-2.2,7.3-2.2,16s0.2,10.5,2.2,16c3.9,11.4,10.3,19.8,19.7,26.2c3.3,2.1,6.8,4.1,7.8,4.4c2.3,0.6,5.5-1.3,6.7-4.1c1.3-2.9-0.2-5.3-5.9-8.9C95.5,118.6,89.2,97,97.9,79.1c5-10.2,13.4-17.5,24.1-20.8c4.5-1.3,6.8-1.6,13.4-1.3c7.2,0.3,8.6,0.6,14,3.2c30.2,14.4,30.9,55.4,1.2,70.9c-6.2,3.2-7,4.1-7,7.8c0,2.6,3.1,5.5,5.9,5.5c3.1,0,12.8-5.5,18-10.4c7.9-7.3,13.3-16.2,15.5-25.7c1.3-5.9,1.5-17.6,0.3-23.4c-0.9-4.1-5.4-14.5-8.3-18.8l-1.4-2.1l16.4-16.4c9-9.1,16.6-16.4,17-16.4c0.4,0,0.6,5.9,0.6,13.1c0,12.7,0.1,13.2,1.8,14.8c2.6,2.4,6.3,2.3,8.3-0.3c1.6-2,1.6-3,1.6-23.4s-0.1-21.3-1.6-23.4l-1.6-2h-22.3C172.8,10,171.7,10.1,170.2,11.6z"/>
		                <path d="M63.6,81.6c-8.2,4.4-17.2,13.6-21.4,22.1c-7.4,15.2-7.4,31,0,46.1c2.6,5.2,4.7,8,9.6,12.9c8.3,8.2,15.5,12,28,14.8l2.1,0.5v14v14l-12,0.3c-10.5,0.2-12.3,0.4-13.7,1.7c-2.5,2.3-2.3,6.9,0.4,9c1.9,1.5,3.1,1.6,13.7,1.6h11.6v11.6c0,10.5,0.2,11.8,1.6,13.7c2,2.6,6.2,2.8,8.5,0.5c1.4-1.4,1.6-2.6,1.6-13.7v-12.1H105c12.5,0,14.6-0.5,16.1-4.1c0.8-1.9,0.8-2.7-0.2-4.4c-2-3.4-4.1-4-16.1-4H93.6V192V178l2.2-0.4c5.9-1.2,15.5-4.8,19.8-7.7c9.7-6.4,16.8-15.5,20.8-26.5c2.7-7.5,3.3-20.2,1.3-28.4c-3.2-14-13.4-27.3-25.8-33.5c-3.4-1.8-4.4-2-6.2-1.3c-2.8,1.1-4.2,3-4.3,5.6c0,2.6,1.9,4.6,6.4,7c7.7,3.9,15.6,14.7,18.2,24.5c4.5,17.3-4.3,36.2-20.5,44.3c-15.9,8-33.7,4.8-45.7-7.8c-5.9-6.2-8.7-11.6-10.4-19.3c-1.4-6.8-1.4-8.8,0-15.6c2.5-11.8,10.2-22,20.4-27c7.6-3.8,9.3-7.4,5.4-11.3C72.7,78,70,78.3,63.6,81.6z"/>
		            </g>
		        </g>
		    </g>
		</svg>
		   
		    <h3 id="tier-starter" class="text-lg font-semibold leading-8">Create Persona</h3>
		    <div class="ml-auto">
		        <p 
		            class="rounded-full text-base font-semibold leading-5 text-gray-400 hover:text-white cursor-default"
		            on:click={closeChatModal}
		        >
		            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
		        </p>
		    </div>
		</div>

			{#if customCharacter}
				<UploadCustomChat {app} {createIsMale} on:customChatInProcess="{customChatInProcess}" />
	    {:else if showCreateChat2}
	    	<button
			    class="mt-6 w-full rounded-lg p-4 text-center text-sm font-medium text-slate-700 transition-colors duration-200 dark:border-slate-700 dark:text-gray-400 cursor-default"
			    type="button"
			  >
			  	{#if createIsMale}
			  		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 1rem; width: auto; display: inline-block; vertical-align: middle; fill: #999999;  margin-top:-1px;"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"/></svg>&nbsp; Create Male Persona
			  	{:else}
			  		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="height: 1rem; width: auto; display: inline-block; vertical-align: middle; fill: #999999; margin-top:-1px;"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"/></svg>&nbsp; Create Female Persona
			  	{/if}
			  </button>

			  <button
			    class="mt-6 w-full rounded-lg border border-slate-300 p-4 text-center text-base font-medium text-slate-700 transition-colors duration-200 hover:bg-blue-600 hover:text-slate-50 focus:outline-none dark:border-slate-700 dark:text-slate-200"
			    type="button"
			    on:click={() => createNewChat(false)} 
			  >
			    Friend &raquo;
			  </button>

			  <button
			    class="mt-10 w-full rounded-lg border border-slate-300 p-2 text-center text-base font-medium text-slate-700 transition-colors duration-200 hover:bg-blue-600 hover:text-slate-50 focus:outline-none dark:border-slate-700 dark:text-slate-200"
			    type="button" 
			    on:click={() => createNewChat(true)} 
			  >
			  	<div>Flirty &raquo;</div>
    			<div class="text-xs text-gray-400 mt-0">* NSFW is possible *</div>
			  </button>

			   <button
			    class="mt-10 w-full rounded-lg border border-slate-300 p-4 text-center text-base font-medium text-slate-700 transition-colors duration-200 hover:bg-blue-600 hover:text-slate-50 focus:outline-none dark:border-slate-700 dark:text-slate-200"
			    type="button" 
			    on:click={() => showCustomCharacter() } 
			  >
			  	Custom &raquo;
			  </button>

			  


	    {:else if  !isCreatingChat}
		    <button
			    class="mt-10 w-full rounded-lg border border-slate-300 p-4 text-center text-base font-medium text-slate-700 transition-colors duration-200 hover:bg-blue-600 hover:text-slate-50 focus:outline-none dark:border-slate-700 dark:text-slate-200"
			    type="button"
			    on:click={() => createChat2(false)} 
			  >
			    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="height: 1rem; width: auto; display: inline-block; vertical-align: middle; fill: #ffffff; margin-top:-1px;"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M80 176a112 112 0 1 1 224 0A112 112 0 1 1 80 176zM224 349.1c81.9-15 144-86.8 144-173.1C368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144 173.1V384H128c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H224V349.1z"/></svg>&nbsp; Create Female Persona
			  </button>

			  <button
			    class="mt-10 w-full rounded-lg border border-slate-300 p-4 text-center text-base font-medium text-slate-700 transition-colors duration-200 hover:bg-blue-600 hover:text-slate-50 focus:outline-none dark:border-slate-700 dark:text-slate-200"
			    type="button"
			    on:click={() => createChat2(true)} 
			  >
			    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 1rem; width: auto; display: inline-block; vertical-align: middle; fill: #ffffff;  margin-top:-1px;"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M289.8 46.8c3.7-9 12.5-14.8 22.2-14.8H424c13.3 0 24 10.7 24 24V168c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-33.4-33.4L321 204.2c19.5 28.4 31 62.7 31 99.8c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c37 0 71.4 11.4 99.8 31l52.6-52.6L295 73c-6.9-6.9-8.9-17.2-5.2-26.2zM400 80l0 0h0v0zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"/></svg>&nbsp; Create Male Persona
			  </button>

			  <PresetRow presets={presets} on:setPreset={e => setPreset(e.detail)} />

		{:else}

		    <ul
		      role="list"
		      class="mt-8 space-y-3 text-base leading-6 text-slate-700 dark:text-slate-300"
		    >
		      <li class="flex items-center gap-x-3">
		        {#if currTempChat && currTempChat.title}
		        	<svg
			          xmlns="http://www.w3.org/2000/svg"
			          class="h-8 w-7 flex-none text-blue-600"
			          viewBox="0 0 24 24"
			          stroke-width="2"
			          stroke="currentColor"
			          fill="none"
			          stroke-linecap="round"
			          stroke-linejoin="round"
			        >
			          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
			          <path d="M9 12l2 2l4 -4"></path>
			        </svg>
			        {currTempChat.title}
		        {:else}
			        <svg
					    xmlns="http://www.w3.org/2000/svg"
					    class="h-8 w-7 flex-none"
					    viewBox="0 0 24 24"
					    fill="none"
					    stroke="currentColor"
					    stroke-width="2"
					    stroke-linecap="round"
					    stroke-linejoin="round"
					    style="animation: slow-spin 2s linear infinite;"
					>
					    <circle cx="12" cy="12" r="10" stroke-opacity=".3"></circle>
					    <path d="M22 12 L18 12"></path>
					    <path d="M6 12 L2 12"></path>
					    <path d="M12 6 L12 2"></path>
					    <path d="M12 22 L12 18"></path>
					</svg>
			        <LoadingSpinner message="Creating name" />
			    {/if}
		      </li>
		      
		      {#if currTempChat && currTempChat.profilePicUrl}
		        <li class="flex gap-x-3">
		        	<svg
			          xmlns="http://www.w3.org/2000/svg"
			          class="h-8 w-7 flex-none text-blue-600"
			          viewBox="0 0 24 24"
			          stroke-width="2"
			          stroke="currentColor"
			          fill="none"
			          stroke-linecap="round"
			          stroke-linejoin="round"
			        >
			          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
			          <path d="M9 12l2 2l4 -4"></path>
			        </svg>
			        <div class="relative w-full max-w-screen-md h-auto">
					    <img 
					        src={currTempChat.profilePicUrl}
					        alt="Inline Image" 
					        class="max-w-full h-auto"
					        
					    />
					</div>
			     </li>
		        {:else}
		          <li class="flex items-center gap-x-3">
			        <svg
					    xmlns="http://www.w3.org/2000/svg"
					    class="h-8 w-7 flex-none"
					    viewBox="0 0 24 24"
					    fill="none"
					    stroke="currentColor"
					    stroke-width="2"
					    stroke-linecap="round"
					    stroke-linejoin="round"
					    style="animation: slow-spin 2s linear infinite;"
					>
					    <circle cx="12" cy="12" r="10" stroke-opacity=".3"></circle>
					    <path d="M22 12 L18 12"></path>
					    <path d="M6 12 L2 12"></path>
					    <path d="M12 6 L12 2"></path>
					    <path d="M12 22 L12 18"></path>
					</svg>
			        <LoadingSpinner message="Taking HD profile picture" />
			      </li>
			    {/if}



		      <li class="flex gap-x-3 w-full">
		        {#if currTempChat && currTempChat.hasStory}
		        	<svg
			          xmlns="http://www.w3.org/2000/svg"
			          class="h-8 w-7 flex-none text-blue-600"
			          viewBox="0 0 24 24"
			          stroke-width="2"
			          stroke="currentColor"
			          fill="none"
			          stroke-linecap="round"
			          stroke-linejoin="round"
			        >
			          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
			          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
			          <path d="M9 12l2 2l4 -4"></path>
			        </svg>
						  <textarea 
									bind:value={currTempChat.currStory} 
									rows="2" 
									class="flex-1 p-2 bg-blue-100 text-blue-900 border-none rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder-blue-300"
								></textarea>

						  
		        {:else}
			        <svg
					    xmlns="http://www.w3.org/2000/svg"
					    class="h-8 w-7 flex-none"
					    viewBox="0 0 24 24"
					    fill="none"
					    stroke="currentColor"
					    stroke-width="2"
					    stroke-linecap="round"
					    stroke-linejoin="round"
					    style="animation: slow-spin 2s linear infinite;"
					>
					    <circle cx="12" cy="12" r="10" stroke-opacity=".3"></circle>
					    <path d="M22 12 L18 12"></path>
					    <path d="M6 12 L2 12"></path>
					    <path d="M12 6 L12 2"></path>
					    <path d="M12 22 L12 18"></path>
					</svg>
			        <LoadingSpinner message="Creating story" />
			    {/if}
		      </li>



		      <li>
		      	<div class="flex justify-between items-center">
		      	{#if currTempChat && currTempChat.hasStory && currTempChat.profilePicUrl}
					   <button
					    class="bg-transparent border-none text-gray-400 hover:text-gray-500 focus:outline-none"
					    on:click={() => reloadCreateChat(currTempChat.isNsfw)} 
					  >
					    Try again
					  </button>

					  <button
					  type="submit"
					  class="inline-flex items-center gap-x-2 rounded-lg bg-blue-600 px-3.5 py-2.5 text-center text-sm font-medium text-slate-50 hover:bg-blue-800 focus:outline-none focus:ring focus:ring-blue-300"
					  on:click={() => activateTempChat()}
					  disabled={activatingTempChat}
					>
					  {#if activatingTempChat}
					    Please wait...
					  {:else}
					    Continue
					  {/if}
					</button>

				{:else}
					 <button
					    class="bg-transparent border-none text-gray-400 hover:text-gray-500 focus:outline-none opacity-25"
					   
					  >
					    Try again
					  </button>

					  <button
					    type="submit"
					    class="inline-flex items-center gap-x-2 rounded-lg bg-blue-600 px-3.5 py-2.5 text-center text-sm font-medium text-slate-50 hover:bg-blue-800 focus:outline-none focus:ring focus:ring-blue-300 opacity-25 cursor-not-allowed"
					    disabled
					  >
					    Continue
					  </button>

				{/if}
				</div>

			  </li>
			  

		    </ul>
		{/if}
	   </div>


	</div>
</div>
{/if}

{#if isTipsOpen}
<div class="fixed inset-0 w-screen h-screen flex items-center justify-center z-50">
  <!-- Background overlay -->
  <div class="absolute inset-0 bg-black opacity-70" on:click={toggleTips}></div>

  <!-- Modal content -->
  <div class="relative w-[600px] h-[95vh] max-h-[95vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto overflow-x-hidden">

 	<div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
		
	  <div>

	    <div class="flex items-center gap-x-4">
	    	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
		     class="h-9 w-9 text-blue-600"
		     fill="currentColor"
		     stroke="currentColor"
		     stroke-width="5"
		     viewBox="0 0 184 236">
		    <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
		    <g>
		        <g>
		            <g>
		                <path d="M170.2,11.6c-2.2,2.2-2,6.3,0.2,8.4c1.7,1.6,2.6,1.7,15.1,1.7h13.2l-16.9,16.9L165,55.5l-4.9-3.2c-7.8-5.1-15.9-7.3-26.2-7.3c-9.7-0.1-15.8,1.2-23.4,5.1c-12.7,6.4-21.2,16.3-25.9,29.9c-2,5.5-2.2,7.3-2.2,16s0.2,10.5,2.2,16c3.9,11.4,10.3,19.8,19.7,26.2c3.3,2.1,6.8,4.1,7.8,4.4c2.3,0.6,5.5-1.3,6.7-4.1c1.3-2.9-0.2-5.3-5.9-8.9C95.5,118.6,89.2,97,97.9,79.1c5-10.2,13.4-17.5,24.1-20.8c4.5-1.3,6.8-1.6,13.4-1.3c7.2,0.3,8.6,0.6,14,3.2c30.2,14.4,30.9,55.4,1.2,70.9c-6.2,3.2-7,4.1-7,7.8c0,2.6,3.1,5.5,5.9,5.5c3.1,0,12.8-5.5,18-10.4c7.9-7.3,13.3-16.2,15.5-25.7c1.3-5.9,1.5-17.6,0.3-23.4c-0.9-4.1-5.4-14.5-8.3-18.8l-1.4-2.1l16.4-16.4c9-9.1,16.6-16.4,17-16.4c0.4,0,0.6,5.9,0.6,13.1c0,12.7,0.1,13.2,1.8,14.8c2.6,2.4,6.3,2.3,8.3-0.3c1.6-2,1.6-3,1.6-23.4s-0.1-21.3-1.6-23.4l-1.6-2h-22.3C172.8,10,171.7,10.1,170.2,11.6z"/>
		                <path d="M63.6,81.6c-8.2,4.4-17.2,13.6-21.4,22.1c-7.4,15.2-7.4,31,0,46.1c2.6,5.2,4.7,8,9.6,12.9c8.3,8.2,15.5,12,28,14.8l2.1,0.5v14v14l-12,0.3c-10.5,0.2-12.3,0.4-13.7,1.7c-2.5,2.3-2.3,6.9,0.4,9c1.9,1.5,3.1,1.6,13.7,1.6h11.6v11.6c0,10.5,0.2,11.8,1.6,13.7c2,2.6,6.2,2.8,8.5,0.5c1.4-1.4,1.6-2.6,1.6-13.7v-12.1H105c12.5,0,14.6-0.5,16.1-4.1c0.8-1.9,0.8-2.7-0.2-4.4c-2-3.4-4.1-4-16.1-4H93.6V192V178l2.2-0.4c5.9-1.2,15.5-4.8,19.8-7.7c9.7-6.4,16.8-15.5,20.8-26.5c2.7-7.5,3.3-20.2,1.3-28.4c-3.2-14-13.4-27.3-25.8-33.5c-3.4-1.8-4.4-2-6.2-1.3c-2.8,1.1-4.2,3-4.3,5.6c0,2.6,1.9,4.6,6.4,7c7.7,3.9,15.6,14.7,18.2,24.5c4.5,17.3-4.3,36.2-20.5,44.3c-15.9,8-33.7,4.8-45.7-7.8c-5.9-6.2-8.7-11.6-10.4-19.3c-1.4-6.8-1.4-8.8,0-15.6c2.5-11.8,10.2-22,20.4-27c7.6-3.8,9.3-7.4,5.4-11.3C72.7,78,70,78.3,63.6,81.6z"/>
		            </g>
		        </g>
		    </g>
		</svg>
		   
		    <h3 id="tier-starter" class="text-lg font-semibold leading-8">{appTitle}</h3>
		    <div class="ml-auto">
		        <p 
		            class="rounded-full text-base font-semibold leading-5 text-gray-400 hover:text-white cursor-default"
		            on:click={toggleTips}
		        >
		            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
		        </p>
		    </div>
		</div>



<div class="p-4 mt-6 rounded-lg shadow-md space-y-4">
  <h2 class="text-xl font-bold">Tips for a Smooth {appPageTitle} Journey 🚀</h2>
  
  <ul class="list-decimal pl-5 space-y-4">
    <li class="text-sm">
      <span class="font-semibold">Engage & Introduce:</span> Dive into the narrative! Play along and feel free to introduce your AI companions to friends and fellow adventurers.
    </li>
    <li class="text-sm">
      <span class="font-semibold">Steer the Conversation:</span> If your chat seems astray, don't hesitate to tap the refresh button. It'll guide the conversation back on course.
    </li>
    <li class="text-sm">
      <span class="font-semibold">Patience Pays in Pixels:</span> Our high-definition 1024p imagery takes a moment to craft. Trust us, the wait is worth every stunning pixel!
    </li>
    <li class="text-sm">
      <span class="font-semibold">Directing the Story:</span> When you wish to add an action or narration instead of dialog, click the "Reply:" dropdown and select "Action:". This enables you to influence and direct the unfolding adventure in exciting, new directions!
    </li>
     

  </ul>

  <p class="text-gray-300 text-sm">Enjoy your voyage through the endless AI cosmos.</p>
</div>





	   </div>


	</div>
</div>
{/if}


{#if !userAccepted}
<div class="fixed inset-0 w-screen h-screen flex items-center justify-center z-50">
  <!-- Background overlay -->
  <div class="absolute inset-0 bg-black opacity-70"></div>

  <!-- Modal content -->
  <div class="relative w-[600px] h-[95vh] max-h-[95vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto overflow-x-hidden">

	<div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
 
		
	  <div>
	    
	    <div class="flex items-center gap-x-4">
	    	
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
     class="h-9 w-9 text-blue-600"
     fill="currentColor"
     stroke="currentColor"
     stroke-width="5"
     viewBox="0 0 184 236">
    <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
    <g>
        <g>
            <g>
                <path d="M170.2,11.6c-2.2,2.2-2,6.3,0.2,8.4c1.7,1.6,2.6,1.7,15.1,1.7h13.2l-16.9,16.9L165,55.5l-4.9-3.2c-7.8-5.1-15.9-7.3-26.2-7.3c-9.7-0.1-15.8,1.2-23.4,5.1c-12.7,6.4-21.2,16.3-25.9,29.9c-2,5.5-2.2,7.3-2.2,16s0.2,10.5,2.2,16c3.9,11.4,10.3,19.8,19.7,26.2c3.3,2.1,6.8,4.1,7.8,4.4c2.3,0.6,5.5-1.3,6.7-4.1c1.3-2.9-0.2-5.3-5.9-8.9C95.5,118.6,89.2,97,97.9,79.1c5-10.2,13.4-17.5,24.1-20.8c4.5-1.3,6.8-1.6,13.4-1.3c7.2,0.3,8.6,0.6,14,3.2c30.2,14.4,30.9,55.4,1.2,70.9c-6.2,3.2-7,4.1-7,7.8c0,2.6,3.1,5.5,5.9,5.5c3.1,0,12.8-5.5,18-10.4c7.9-7.3,13.3-16.2,15.5-25.7c1.3-5.9,1.5-17.6,0.3-23.4c-0.9-4.1-5.4-14.5-8.3-18.8l-1.4-2.1l16.4-16.4c9-9.1,16.6-16.4,17-16.4c0.4,0,0.6,5.9,0.6,13.1c0,12.7,0.1,13.2,1.8,14.8c2.6,2.4,6.3,2.3,8.3-0.3c1.6-2,1.6-3,1.6-23.4s-0.1-21.3-1.6-23.4l-1.6-2h-22.3C172.8,10,171.7,10.1,170.2,11.6z"/>
                <path d="M63.6,81.6c-8.2,4.4-17.2,13.6-21.4,22.1c-7.4,15.2-7.4,31,0,46.1c2.6,5.2,4.7,8,9.6,12.9c8.3,8.2,15.5,12,28,14.8l2.1,0.5v14v14l-12,0.3c-10.5,0.2-12.3,0.4-13.7,1.7c-2.5,2.3-2.3,6.9,0.4,9c1.9,1.5,3.1,1.6,13.7,1.6h11.6v11.6c0,10.5,0.2,11.8,1.6,13.7c2,2.6,6.2,2.8,8.5,0.5c1.4-1.4,1.6-2.6,1.6-13.7v-12.1H105c12.5,0,14.6-0.5,16.1-4.1c0.8-1.9,0.8-2.7-0.2-4.4c-2-3.4-4.1-4-16.1-4H93.6V192V178l2.2-0.4c5.9-1.2,15.5-4.8,19.8-7.7c9.7-6.4,16.8-15.5,20.8-26.5c2.7-7.5,3.3-20.2,1.3-28.4c-3.2-14-13.4-27.3-25.8-33.5c-3.4-1.8-4.4-2-6.2-1.3c-2.8,1.1-4.2,3-4.3,5.6c0,2.6,1.9,4.6,6.4,7c7.7,3.9,15.6,14.7,18.2,24.5c4.5,17.3-4.3,36.2-20.5,44.3c-15.9,8-33.7,4.8-45.7-7.8c-5.9-6.2-8.7-11.6-10.4-19.3c-1.4-6.8-1.4-8.8,0-15.6c2.5-11.8,10.2-22,20.4-27c7.6-3.8,9.3-7.4,5.4-11.3C72.7,78,70,78.3,63.6,81.6z"/>
            </g>
        </g>
    </g>
</svg>
		    <h3 id="tier-starter" class="text-lg font-semibold leading-8">{appPageTitle}</h3>
		    <div class="ml-auto">
		        
		    </div>
		</div>

				<div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
				    <p class="mb-4">
				      Welcome to {appPageTitle} (Beta) 🌌
				    </p>
				    <p class="mb-4">
				      Embark on a journey into the vast horizons of cutting-edge AI.
				    </p>
				    <p class="mb-4">
				      Embrace the raw authenticity: our models know no bounds and the unexpected is part of the adventure. Proceed with curiosity!
				    </p>
				    <p class="mb-4 font-bold">
				      Important:
				    </p>
				    <ul class="list-disc pl-5 mb-4">
				      <li>You must be 18 years or older to use this app.</li>
				      <li>By continuing, you confirm that you are at least 18 years of age and agree to our <a on:click={showPrivacyPolicy} class="text-blue-500 underline cursor-pointer">Privacy Policy</a> & <a on:click={showTermsOfUse} class="text-blue-500 underline cursor-pointer">Terms of Use</a>.</li>
				    </ul>
				</div>
				<div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
				    <button 
				      on:click={acceptWarning}
				      class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Accept</button>
				    
				</div>
<!--
	    	<div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
	        <p class="mb-4">
	        	Welcome to {appPageTitle} (Beta) 🌌
	        </p>
	        <p class="mb-4">
						Embark on a journey into the vast horizons of cutting-edge AI.
					</p>
					<p class="mb-4">
						Embrace the raw authenticity: our models know no bounds and the unexpected is part of the adventure. Proceed with curiosity!
					</p>
	      </div>
	      <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
	        <button 
	        	on:click={acceptWarning}
	        	class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Accept</button>
	      </div>
	    -->

	   </div>


	</div>
</div>
{/if}

{#if isFbFormOpen}
  <FeedbackForm {appPageTitle} {closeFbForm} />
{/if}

{#if editingDbUser}
    <EditUser {appPageTitle}  {dbUser} {toggleDbUser} {logout} on:update={handleDbUserUpdate} />
  {/if}

{#if isEditingChat}
    <EditChat {appPageTitle} {dbUser} {toggleEditChat} {currChatRecord} on:update={handleChatUpdate} on:delete={handleDeleteChat}/>
  {/if}

{#if showWelcome}
<div class="fixed inset-0 w-screen h-screen flex items-center justify-center z-50">
  <!-- Background overlay -->
  <div class="absolute inset-0 bg-black opacity-70"></div>

  <!-- Modal content -->
  <div class="relative w-[600px] h-[95vh] max-h-[95vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto overflow-x-hidden">

	<div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
 
		
	  <div>
	    
	    <div class="flex items-center gap-x-4">
	    	
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
     class="h-9 w-9 text-blue-600"
     fill="currentColor"
     stroke="currentColor"
     stroke-width="5"
     viewBox="0 0 184 236">
    <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
    <g>
        <g>
            <g>
                <path d="M170.2,11.6c-2.2,2.2-2,6.3,0.2,8.4c1.7,1.6,2.6,1.7,15.1,1.7h13.2l-16.9,16.9L165,55.5l-4.9-3.2c-7.8-5.1-15.9-7.3-26.2-7.3c-9.7-0.1-15.8,1.2-23.4,5.1c-12.7,6.4-21.2,16.3-25.9,29.9c-2,5.5-2.2,7.3-2.2,16s0.2,10.5,2.2,16c3.9,11.4,10.3,19.8,19.7,26.2c3.3,2.1,6.8,4.1,7.8,4.4c2.3,0.6,5.5-1.3,6.7-4.1c1.3-2.9-0.2-5.3-5.9-8.9C95.5,118.6,89.2,97,97.9,79.1c5-10.2,13.4-17.5,24.1-20.8c4.5-1.3,6.8-1.6,13.4-1.3c7.2,0.3,8.6,0.6,14,3.2c30.2,14.4,30.9,55.4,1.2,70.9c-6.2,3.2-7,4.1-7,7.8c0,2.6,3.1,5.5,5.9,5.5c3.1,0,12.8-5.5,18-10.4c7.9-7.3,13.3-16.2,15.5-25.7c1.3-5.9,1.5-17.6,0.3-23.4c-0.9-4.1-5.4-14.5-8.3-18.8l-1.4-2.1l16.4-16.4c9-9.1,16.6-16.4,17-16.4c0.4,0,0.6,5.9,0.6,13.1c0,12.7,0.1,13.2,1.8,14.8c2.6,2.4,6.3,2.3,8.3-0.3c1.6-2,1.6-3,1.6-23.4s-0.1-21.3-1.6-23.4l-1.6-2h-22.3C172.8,10,171.7,10.1,170.2,11.6z"/>
                <path d="M63.6,81.6c-8.2,4.4-17.2,13.6-21.4,22.1c-7.4,15.2-7.4,31,0,46.1c2.6,5.2,4.7,8,9.6,12.9c8.3,8.2,15.5,12,28,14.8l2.1,0.5v14v14l-12,0.3c-10.5,0.2-12.3,0.4-13.7,1.7c-2.5,2.3-2.3,6.9,0.4,9c1.9,1.5,3.1,1.6,13.7,1.6h11.6v11.6c0,10.5,0.2,11.8,1.6,13.7c2,2.6,6.2,2.8,8.5,0.5c1.4-1.4,1.6-2.6,1.6-13.7v-12.1H105c12.5,0,14.6-0.5,16.1-4.1c0.8-1.9,0.8-2.7-0.2-4.4c-2-3.4-4.1-4-16.1-4H93.6V192V178l2.2-0.4c5.9-1.2,15.5-4.8,19.8-7.7c9.7-6.4,16.8-15.5,20.8-26.5c2.7-7.5,3.3-20.2,1.3-28.4c-3.2-14-13.4-27.3-25.8-33.5c-3.4-1.8-4.4-2-6.2-1.3c-2.8,1.1-4.2,3-4.3,5.6c0,2.6,1.9,4.6,6.4,7c7.7,3.9,15.6,14.7,18.2,24.5c4.5,17.3-4.3,36.2-20.5,44.3c-15.9,8-33.7,4.8-45.7-7.8c-5.9-6.2-8.7-11.6-10.4-19.3c-1.4-6.8-1.4-8.8,0-15.6c2.5-11.8,10.2-22,20.4-27c7.6-3.8,9.3-7.4,5.4-11.3C72.7,78,70,78.3,63.6,81.6z"/>
            </g>
        </g>
    </g>
</svg>
		    <h3 id="tier-starter" class="text-lg font-semibold leading-8">{appTitle}</h3>
		    <div class="ml-auto">
		        
		    </div>
		</div>

	    <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
	        <!--<h2 class="text-xl font-bold">Warning</h2>-->
	        <p class="mb-4">
	        Welcome!</p>
			<p>Your previous personas will load in a moment.</p>
	      </div>
	      <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
	        <button 
	        	on:click={closeWelcome}
	        	class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">Continue</button>
	      </div>

	   </div>


	</div>
</div>
{/if}
{#if showPrivacyModal}
  <PrivacyPolicyModal close={closePrivacyPolicy} />
{/if}
{#if showTermsModal}
  <TermsOfUseModal close={closeTermsOfUse} />
{/if}

<!-- Request Access Form -->
{:else}

<div class="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-gray-800 p-1 z-10">
	<div class="relative w-[600px] h-[88vh] max-h-[88vh] flex flex-col justify-between rounded-3xl bg-slate-50 p-8 text-slate-900 ring-1 ring-slate-300 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-300/20 xl:p-10 z-10 overflow-y-auto overflow-x-hidden">

	  

		<div class="absolute left-[calc(50%-4rem)] -z-10 transform-gpu blur-3xl sm:left-[calc(50%-18rem)] lg:left-48 lg:top-[calc(50%-30rem)] xl:left-[calc(50%-24rem)] top-10" aria-hidden="true"><div class="aspect-[1108/632] w-[69.25rem] bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-20" style="clip-path: polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%);"></div></div>
 
		
	  <div>
	    
	    <div class="flex items-center gap-x-4">
	    	
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" 
				     class="h-9 w-9 text-blue-600"
				     fill="currentColor"
				     stroke="currentColor"
				     stroke-width="5"
				     viewBox="0 0 184 236">
				    <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon </metadata>
				    <g>
				        <g>
				            <g>
				                <path d="M170.2,11.6c-2.2,2.2-2,6.3,0.2,8.4c1.7,1.6,2.6,1.7,15.1,1.7h13.2l-16.9,16.9L165,55.5l-4.9-3.2c-7.8-5.1-15.9-7.3-26.2-7.3c-9.7-0.1-15.8,1.2-23.4,5.1c-12.7,6.4-21.2,16.3-25.9,29.9c-2,5.5-2.2,7.3-2.2,16s0.2,10.5,2.2,16c3.9,11.4,10.3,19.8,19.7,26.2c3.3,2.1,6.8,4.1,7.8,4.4c2.3,0.6,5.5-1.3,6.7-4.1c1.3-2.9-0.2-5.3-5.9-8.9C95.5,118.6,89.2,97,97.9,79.1c5-10.2,13.4-17.5,24.1-20.8c4.5-1.3,6.8-1.6,13.4-1.3c7.2,0.3,8.6,0.6,14,3.2c30.2,14.4,30.9,55.4,1.2,70.9c-6.2,3.2-7,4.1-7,7.8c0,2.6,3.1,5.5,5.9,5.5c3.1,0,12.8-5.5,18-10.4c7.9-7.3,13.3-16.2,15.5-25.7c1.3-5.9,1.5-17.6,0.3-23.4c-0.9-4.1-5.4-14.5-8.3-18.8l-1.4-2.1l16.4-16.4c9-9.1,16.6-16.4,17-16.4c0.4,0,0.6,5.9,0.6,13.1c0,12.7,0.1,13.2,1.8,14.8c2.6,2.4,6.3,2.3,8.3-0.3c1.6-2,1.6-3,1.6-23.4s-0.1-21.3-1.6-23.4l-1.6-2h-22.3C172.8,10,171.7,10.1,170.2,11.6z"/>
				                <path d="M63.6,81.6c-8.2,4.4-17.2,13.6-21.4,22.1c-7.4,15.2-7.4,31,0,46.1c2.6,5.2,4.7,8,9.6,12.9c8.3,8.2,15.5,12,28,14.8l2.1,0.5v14v14l-12,0.3c-10.5,0.2-12.3,0.4-13.7,1.7c-2.5,2.3-2.3,6.9,0.4,9c1.9,1.5,3.1,1.6,13.7,1.6h11.6v11.6c0,10.5,0.2,11.8,1.6,13.7c2,2.6,6.2,2.8,8.5,0.5c1.4-1.4,1.6-2.6,1.6-13.7v-12.1H105c12.5,0,14.6-0.5,16.1-4.1c0.8-1.9,0.8-2.7-0.2-4.4c-2-3.4-4.1-4-16.1-4H93.6V192V178l2.2-0.4c5.9-1.2,15.5-4.8,19.8-7.7c9.7-6.4,16.8-15.5,20.8-26.5c2.7-7.5,3.3-20.2,1.3-28.4c-3.2-14-13.4-27.3-25.8-33.5c-3.4-1.8-4.4-2-6.2-1.3c-2.8,1.1-4.2,3-4.3,5.6c0,2.6,1.9,4.6,6.4,7c7.7,3.9,15.6,14.7,18.2,24.5c4.5,17.3-4.3,36.2-20.5,44.3c-15.9,8-33.7,4.8-45.7-7.8c-5.9-6.2-8.7-11.6-10.4-19.3c-1.4-6.8-1.4-8.8,0-15.6c2.5-11.8,10.2-22,20.4-27c7.6-3.8,9.3-7.4,5.4-11.3C72.7,78,70,78.3,63.6,81.6z"/>
				            </g>
				        </g>
				    </g>
				</svg>
		    <h3 id="tier-starter" class="text-lg font-semibold leading-8">Join the {appPageTitle} Beta</h3>
		    <div class="ml-auto">
		        
		    </div>
		</div>

	   <div class="pt-16 {isMobile ? '' : 'px-8'}">
    <p class="text-base font-medium text-gray-200 mb-6">
        Discover <span class="font-bold text-white">{appTitle}</span> - where generative AI crafts enchanting, immersive experiences filled with surprise and magic.
    </p>

    {#if !isRequestEmailSuccess}
    <div class="mt-4 {isMobile ? '' : 'p-4'} rounded-lg flex items-center">
        <input bind:value={requestEmail} type="email" placeholder="Enter your email" class="p-2 flex-1 rounded-l-lg border-t border-b border-l border-gray-500 bg-gray-800 text-gray-200 placeholder-gray-500 outline-none"/>
        <button on:click={requestAccess} class="p-2 rounded-r-lg bg-gray-600 text-white hover:bg-gray-500 whitespace-nowrap focus:outline-none">Request Access</button>
    </div>
    {:else}
    <div class="mt-4 p-4 rounded-lg bg-gray-800 text-gray-200">
        Thank you! Your request has been received. We'll be in touch soon.
    </div>
    {/if}
</div>


	      



	</div>
</div>
</div>

 
{/if}
 



<!--

/*
mode: 'jit',
  theme: {
    extend: {
      backgroundColor: {
        'slate-801': '#383E52',
        'slate-802': '#393C53',
        'slate-803': '#3A3B54',
        'slate-804': '#3B3A55',
        'slate-805': '#3C3956',
        'slate-806': '#3D3857',
        'slate-807': '#3E3758',
        'slate-808': '#3F3659',
        'slate-809': '#40365A',
      }
    }
  },

  bg-[#383E52]
  */
-->


